<template>
  <div class="filter-container">
    <PrepareOfferDialog
      :show.sync="prepareOfferReview.show"
      :loading="prepareOfferReview.loading"
      :applicationList="prepareOfferReview.applications"
      @send="openPrepareOffer"
      @openDetail="handleOpenDetail"
    />
    <FilterList
      class="applicant-list"
      ref="filterList"
      showAISearch
      isJobApplicantList
      hiddenMyCandidateSwitch
      hiddenEmployeeIdSearch
      :candidateList="candidateList"
      :listLoading="listLoading"
      :searchTemplate.sync="searchTemplate"
      :searchTemplateList="searchTemplateList"
      :filterGroupList="filterList"
      :actionList="actionList"
      :aiAnalysisActionList="aiAnalysisActionList"
      :addBtnList="addBtnList"
      :operationList="operationList"
      :candidateTotalCount="candidateTotalCount"
      :currentSelectedCount="currentSelectedCount"
      :pagination="pagination"
      :jobName="jobName"
      :hasSoftUserPermission="hasSoftUserPermission"
      :noAction="noAction"
      :tooltip="tooltip"
      @selectedChange="handleSelectedChange"
      @selectAll="handleSelectAll"
      @search="handelSearch"
      @scrollBottom="handleScrollBottom"
      @orderChange="handleOrderChange"
      @openDetail="handleOpenDetail"
      @candidateStatusClick="handleCandidateStatusClick"
      @createSearchTemplate="handleCreateSearchTemplate"
      @updateSearchTemplate="handleUpdateSearchTemplate"
      @clearSearchTemplate="handleClearSearchTemplate"
      @deleteSearchTemplate="handleDeleteSearchTemplate"
      @selectAllCard="handleSelectAllCard"
      @scrollToTop="handleScrollToTop"
      @expandChange="expandChange"
    >
      <template #topContainer>
        <div class="status-stage-board">
          <div v-if="job" class="applicant-count-container">
            <div class="count-container total">
              <span class="number">
                <div class="text" @click="handleStatusFilter">{{ job.applicant_info.total | formatBigNumber }}</div>
                <el-tooltip
                  v-if="job.applicant_info.not_view"
                  effect="light"
                  popper-class="light-tooltip-popper"
                  :content="$t(`${i18nPrefix}.label.new`)"
                >
                  <div class="un-read-container" @click.stop="handleReadStatusFilter">{{ job.applicant_info.not_view|formatBigNumber }}</div>
                </el-tooltip>
              </span>
              <span class="label">{{ $t(`${i18nPrefix}.label.all`) }}</span>
            </div>
            <div
              v-for="(group, index) in applicantCountGroup"
              :key="index"
              :class="`count-container ${group.name}`"
            >
              <div class="number-box">
                <span class="number" @click="handleStatusFilter($event, group)">{{ (group.count) }}</span>
                <el-popover
                  v-if="group.count"
                  v-model="group.expand"
                  placement="bottom"
                  trigger="click"
                  :visible-arrow="false">
                  <div class="popover-count-container">
                    <div
                      v-for="statusInfo in group.statusList"
                      :key="statusInfo.key"
                    >
                      <span class="count" :class="[statusInfo.count && 'has-count']" @click.stop="handleStatusFilter($event, null, statusInfo.key)">{{ formatBigNumber(statusInfo.count) }}</span>
                      <div class="status-name">{{ statusInfo.label }}</div>
                    </div>
                  </div>
                  <i class="expand-button" slot="reference" :class="[group.expand ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"/>
                </el-popover>
              </div>
              <span class="label">{{ group.label }}</span>
            </div>
            <div v-if="hasLeadsPermission" class="count-container leads">
              <span class="number" @click="handleOpenPotential">{{ formatBigNumber(job.applicant_info.leads) }}</span>
              <span class="label">{{ $t(`${i18nPrefix}.label.leads`) }}</span>
            </div>
            <div class="count-container open-days">
              <span class="number">{{ job.open_days | formatBigNumber }}</span>
              <span class="label">{{ $t(`${i18nPrefix}.label.openDays`) }}</span>
            </div>
          </div>
          <RectLoading v-show="jobLoading" class="loading"/>
        </div>
      </template>
      <template v-if="hasSatisfactionSurveyPermission" #chart>
        <div class="nps-chart-container">
          <div class="text">
            <div class="title">{{ $t(`${i18nPrefix}.label.candidateNPS`) }}</div>
            <div class="description">
              <span class="text">{{ `N=${nps.nValue} (${nps.inviteCount}, ${nps.rate}%)` }}</span>
              <el-tooltip
                effect="light"
                popper-class="light-tooltip-popper"
              >
                <template #content>
                  <div>{{ $t(`${i18nPrefix}.message.npsHelpTip.count`) }}</div>
                  <div>{{ $t(`${i18nPrefix}.message.npsHelpTip.inviteCount`, { invitationCount: nps.inviteCount }) }}</div>
                  <div>{{ $t(`${i18nPrefix}.message.npsHelpTip.rate`, { rate: nps.rate }) }}</div>
                </template>
                <i class="tip-icon iconfont iconbianzu1"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="nps-chart" ref="npsChart"></div>
        </div>
      </template>
      <template #tableContainer>
        <TableList
          ref="tableContainer"
          :data="candidateList"
          :cancelSelectedCandidateList="cancelSelectedCandidateList"
          :operationList="tableOperationList"
          :loading="listLoading"
          :showProblemSolvingFit="showProblemSolvingFit"
          :showAssessmentFit="showAssessmentFit"
          :showAiInterviewFit="needShowAiInterview"
          :isDisabled="noAction"
          :tooltip="tooltip"
          :showAIInterviewScore="hasAIInterviewPermission"
          :showInterviewScore="hasInterviewPermission"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
          @openDuplicateCandidateDetail="openDuplicateCandidateDetail"
        ></TableList>
      </template>
      <template #cardContainer>
        <CardList
          ref="cardContainer"
          showQuicklyChangeStatus
          showResumeFit
          :data="candidateList"
          :operationList="operationList"
          :loading="listLoading"
          :showProblemSolvingFit="showProblemSolvingFit"
          :showAssessmentFit="showAssessmentFit"
          :statusGroupList="statusGroupList"
          :showAiInterviewFit="needShowAiInterview"
          :isDisabled="noAction"
          :tooltip="tooltip"
          :showAIInterviewScore="hasAIInterviewPermission"
          :showInterviewScore="hasInterviewPermission"
          @selectedChange="handleSelectedChange"
          @selectAll="handleSelectAll"
          @scrollBottom="handleScrollBottom"
          @orderChange="handleOrderChange"
          @openDetail="handleOpenDetail"
          @candidateStatusClick="handleCandidateStatusClick"
          @changeStatus="handleChangeStatus"
          @toRejectStatus="handleToRejectStatus"
        ></CardList>
      </template>
      <template #filterTip="{filter}">
        <label class="filter-label">{{ filter.label }}</label>
        <i v-auto-tooltip.always="filter.tip" class="filter-tip-icon el-icon-question"></i>
      </template>
    </FilterList>
    <InviteHmRatingDialog
      ref="inviteHmRatingDialog"
      :applicationList="ratingDialog.applicationList"
      :isAllApplication="ratingDialog.isSelectAll"
      :searchParams="searchParams"
      @sent="handleSentHmRatingInvite"
    >
    </InviteHmRatingDialog>
    <InviteInterviewDialog
      ref="inviteInterviewDialog"
      :applicationList="interviewDialog.applicationList"
      :isAllApplication="interviewDialog.isSelectAll"
      :searchParams="searchParams"
      @sent="handleSentInterviewInvite"
    >
    </InviteInterviewDialog>
    <CopyCandidateDialog
      ref="copyCandidateDialog"
      :applicationList="copyCandidateDialog.applicationList"
      :isAllApplication="copyCandidateDialog.isSelectAll"
      :jobId="jobId"
      :searchParams="searchParams"
    ></CopyCandidateDialog>
    <ChangeCandidateStatusDialog
      ref="changeCandidateStatusDialog"
      :defaultStatus="changeCandidateStatusDialog.defaultStatusKey"
      :isAllApplication="changeCandidateStatusDialog.isSelectAll"
      :applicationList="changeCandidateStatusDialog.applicationList"
      :loadedStatusList="statusList"
      :jobId="jobId"
      :searchParams="searchParams"
      @success="handleChangeStatusSuccess"
    ></ChangeCandidateStatusDialog>
    <InviteOpenQuestionDialog
      ref="inviteQuestionDialog"
      :jobId="jobId"
      :isAllApplication="questionDialog.isSelectAll"
      :applicationList="questionDialog.applicationList"
      :searchParams="searchParams"
      @success="handleInviteOpenQuestionSuccess"
    />
    <InviteOnboardingDialog
      ref="inviteOnboardingDialog"
      :jobId="jobId"
      :isAllApplication="onboardingDialog.isSelectAll"
      :applicationList="onboardingDialog.applicationList"
      :searchParams="searchParams"
      @invited="handleInvitedOnboardingSuccess"
    />
    <InviteSatisfactionDialog
      ref="inviteSatisfactionDialog"
      :jobId="jobId"
      :isAllApplication="satisfactionDialog.isSelectAll"
      :applicationList="satisfactionDialog.applicationList"
      :searchParams="searchParams"
    />
    <InvitePortalDialog
      ref="invitePortalDialog"
      :jobId="jobId"
      :isAllApplication="portalDialog.isSelectAll"
      :applicationList="portalDialog.applicationList"
      :searchParams="searchParams"
    />
    <AddCandidateToGroupVue
      ref="addGroupDialog"
      :groupList="groupList"
      :talentPoolGroupList="talentGroupList"
      :isOperator="addCandidateGroupDialog.isOperator"
      @save="saveAddedGroup"
      @saveOperator="handleSaveOperatorCandidateToGroup"
    />
    <MoveGroupDialog
      ref="moveGroupDialog"
      :groupList="groupList"
      :selectedGroupList="groupList"
      :isOperator="moveCandidateGroupDialog.isOperator"
      :i18nTitleKey="'move'"
      @save="handleSaveMovedGroup"
      @saveOperator="handleSaveOperatorMovedGroup"
    ></MoveGroupDialog>
    <MoveGroupDialog
      ref="removedGroupDialog"
      :isRemoved="true"
      :selectedGroupList="groupList"
      :isOperator="removeCandidateGroupDialog.isOperator"
      :i18nTitleKey="'remove'"
      @save="handleSaveRemovedGroup"
      @saveOperator="handleSaveOperatorRemovedGroup"
    ></MoveGroupDialog>
    <ExportCandidateAllInfoDialog
      ref="exportCandidateAllInfoDialog"
      :exportInfo="exportInfo"
      :isOperator="exportCandidateAllInfoDialog.isOperator"
      @save="saveExportCandidateAllInfo"
      @saveOperator="handleSaveOperatorExportCandidateAllInfo"
    ></ExportCandidateAllInfoDialog>
    <ContactCandidate
      ref="contactDialog"
      :jobId="jobId"
      :candidateIds="contactDialog.candidateIds"
      :isAllCandidate="contactDialog.isSelectAll"
      :searchParams="searchParams"
      @success="handleContactCandidateSuccess"
    />
    <AddTagDialog
      ref="addTagDialog"
      :jobId="jobId"
      :candidateList="addTagDialog.candidateList"
      :isAllApplication="addTagDialog.isSelectAll"
      :searchParams="searchParams"
      @success="handleAddTagSuccess"
    ></AddTagDialog>
    <AddComment
      ref="addCommentDialog"
      showInterviewerCanView
      :jobId="jobId"
      :candidateId="commentDialog.candidateId"
    />
    <AIComparisonDialog
      :show.sync="aiComparisonDialog.show"
      :aiComparisonLoading.sync="aiComparisonDialog.aiComparisonLoading"
      :loading.sync=aiComparisonDialog.loading
      :jobId="jobId"
      :categories="aiComparisonDialog.categories"
      :applicationList="aiComparisonDialog.applicationList"
      :comparisonResultList="aiComparisonDialog.comparisonResultList"
      @openDetail="handleOpenCandidateDetail"
    ></AIComparisonDialog>
    <AIComparisonHistoryDialog
      :show.sync="aiComparisonHistoryDialog.show"
      :jobId="aiComparisonHistoryDialog.jobId"
      @viewAIComparison="handleViewAIComparison"
    ></AIComparisonHistoryDialog>
    <DialogWrapper
      class="confirm-create-job-criterion-dialog"
      closeOnCancel
      :showClose="false"
      :close-on-click-modal="false"
      :title="$t(`${i18nPrefix}.message.aiComparisonCriterionError`)"
      :show.sync="createJobCriterionConfirmDialog.show"
      :loading="createJobCriterionConfirmDialog.loading"
    >
      <span class="content-text">{{ $t(`${i18nPrefix}.message.aiComparisonCriterionErrorContent`) }}</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="footer-btn cancel-btn" @click="handleCancelCreateJobCriterion">{{ $t('common.btn.cancel') }}</el-button>
          <el-button class="footer-btn save-btn" @click="handleConfirmCreateJobCriterion">
            <span class="label">{{ $t('common.btn.generate') }}</span>
            <i class="btn-icon iconfont icona-ResumeSummary"></i>
          </el-button>
        </div>
      </template>
    </DialogWrapper>
    <DialogWrapper
      class="confirm-create-job-criterion-dialog"
      closeOnCancel
      :showClose="false"
      :close-on-click-modal="false"
      :title="$t(`${i18nPrefix}.label.refreshAllCandidateAIResumeMatch`)"
      :show.sync="createRefreshAIResumeMatchTaskDialog.show"
      :loading="createRefreshAIResumeMatchTaskDialog.loading"
      @save="handleCreateRefreshAIResumeMatchTask"
    >
      <span class="content-text">{{ createRefreshAIResumeMatchTaskDialog.content }}</span>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import * as echarts from 'echarts'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { addI18nProperty, createI18nProperty, getConstantI18nValue, getI18nPropertyValue, isEn } from '@/i18n'
import { REFERRAL_TYPE, generateFitEchartsOption, SQUARED_UP_MAP, STATUS_STAGE, READ_STATUS, ASSESSMENT_INVITE_TYPE, APPLICATION_STATUS, MUNICIPALITY_CITY, MUNICIPALITY_PROVINCE, GENDER, CONSENT_STATUS, PROBLEM_SOLVING_FIT_RANGE_BAR, CONTACT_STATUS } from '@/constant/application'
import { DEGREE } from '@/constant/meta'
import { HAS_OPTIONS_QUESTION_TYPES } from '@/constant/openQuestion'
import { getScoreColor, AsyncTask, addQueryInPath } from '@/utils/common'
import { formatBigNumber } from '@/components/filters'
import FilterList from '../applicantList/filterList/layout.vue'
import ChangeCandidateStatusDialog from '../applicantList/dialog/changeCandidateStatus.vue'
import DateRage from '../applicantList/dateRange.vue'
import RangeSelect from '../applicantList/rangeSelect.vue'
import CopyCandidateDialog from '../applicantList/dialog/copyCandidateDialog.vue'
import InviteHmRatingDialog from '../applicantList/dialog/inviteHmRating.vue'
import InviteInterviewDialog from '../applicantList/dialog/inviteInterview.vue'
import AssessmentFitChart from './assmentFitChart.vue'
import ProblemSolvingFitChart from './problemSolvingChart.vue'
import InviteOpenQuestionDialog from '../candidate/profile/dialog/inviteOpenQuestion.vue'
import InviteOnboardingDialog from '../candidate/profile/dialog/inviteOnboardingQuestionnaire.vue'
import InviteSatisfactionDialog from '../candidate/profile/dialog/inviteSatisfactionQuestionnaire.vue'
import InvitePortalDialog from '../candidate/profile/dialog/invitePortalQuestionnaire.vue'
import MoveGroupDialog from '../applicantList/dialog/moveCandidateGroup.vue'
import AddCandidateToGroupVue from '../candidate/profile/dialog/addGroupDialog.vue'
import ExportCandidateAllInfoDialog from '../applicantList/dialog/exportCandidateAllInfo.vue'
import ContactCandidate from '../candidate/profile/dialog/contactCandidate.vue'
import CardList from '../application/job/card.vue'
import TableList from './filterList/candidateList.vue'
import GroupSelect from '../applicantList/groupSelect.vue'
import AddTagDialog from '../applicantList/dialog/addTagDialog.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
import AddComment from '@/views/adminNew/candidate/profile/dialog/addComment.vue'
import AIComparisonDialog from './dialog/aiComparison.vue'
import AIComparisonHistoryDialog from './dialog/aiComparisonHistory.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { RESUME_SDK_TAG_TYPES, ROOT_COMPANY_ID, FILTER_GROUP_TYPE, RESUME_SDK_TAG_KEYS, CRM_TAG_TYPES, COMPANY_LEVEL_ORDER_LIST, AI_EXTRA_PARAMS } from '@/constant/company'
import WorkCompanyName from '../applicantList/workCompanyName.vue'
import { JOB_EDITOR_STEP_TYPE } from '@/constant/job'
import applicationApi from '@/api/application'
import { getFileExtension } from '@/utils/oss'
import prepareOfferMixin from '../application/prepareOfferMixin'

const CANDIDATE_TYPE = {
  EMPLOYEE: 'EMPLOYEE',
  CANDIDATE: 'CANDIDATE'
}

const GRADUATION_YEAR_OPTION_LIST = _.range(moment().year() + 4, 1899, -1)
  .map(year => ({ id: year, i18nName: String(year) }))

const PARENT_FIELD_NAME_LIST = {
  CANDIDATE_INFO: 'PersonalInfo',
  APPLICATION_INFO: 'ApplicationInfo',
  FITNESS_INFO: 'FitnessInfo',
  ASSESSMENT_INFO: 'AssessmentInfo',
  INTERN_EXP_INFO: 'InternExperienceInfo',
  WORK_EXP_INFO: 'ExperienceInfo',
  EDUCATION_EXP_INFO: 'EducationInfo',
  ADDITIONAL_INFO: 'AdditionalInfo',
  LANGUAGE_INFO: 'LanguageInfo',
  JOB_SURVEY: 'jobSurveyInfo',
  INTERVIEW_RECORD_INFO: 'interviewRecordInfo',
  CANDIDATE_CONSENT_INFO: 'candidateConsentInfo',
  HM_RATE_INFO: 'hmRateInfo',
  AI_INTERVIEW_INFO: 'aiInterviewInfo'
}

const SELECT_ALL_CANDIDATE_LIMIT = {
  ADD_TAG: 20000,
  EXPORT_ORIGINAL_RESUME: 2000
}

const AI_COMPARISON_CANDIDATE_LIMIT = {
  MIN: 2,
  MAX: 5
}

const APPLICATION_PAGE_KEY = 'application_page_key'

export default {
  mixins: [prepareOfferMixin],
  components: {
    FilterList,
    ChangeCandidateStatusDialog,
    CopyCandidateDialog,
    InviteHmRatingDialog,
    InviteInterviewDialog,
    InviteOpenQuestionDialog,
    InviteOnboardingDialog,
    InviteSatisfactionDialog,
    InvitePortalDialog,
    AddCandidateToGroupVue,
    MoveGroupDialog,
    ExportCandidateAllInfoDialog,
    ContactCandidate,
    TableList,
    CardList,
    AddTagDialog,
    RectLoading,
    AddComment,
    AIComparisonDialog,
    AIComparisonHistoryDialog,
    DialogWrapper
  },
  data () {
    const vm = this
    return {
      i18nPrefix: 'admin.application.applicantList',
      pagination: {
        page: 1,
        pageSize: 20,
        totalPage: 2
      },
      listOrder: {
        prop: 'apply_time',
        order: '-'
      },
      searchTemplate: null,
      searchTemplateList: [],
      savedFilterList: [],
      candidateList: [],
      listLoading: false,
      isSelectedAllCandidate: false,
      isSelectedAllCardCandidate: false,
      selectedCandidateList: [],
      ratingDialog: {
        isSelectAll: false,
        applicationList: []
      },
      interviewDialog: {
        applicationList: [],
        isSelectAll: false
      },
      copyCandidateDialog: {
        isSelectAll: false,
        applicationList: []
      },
      changeCandidateStatusDialog: {
        isSelectAll: false,
        applicationList: []
      },
      questionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      contactDialog: {
        isSelectAll: false,
        candidateIds: []
      },
      commentDialog: {
        isSelectAll: false,
        candidateId: null
      },
      onboardingDialog: {
        isSelectAll: false,
        applicationList: []
      },
      satisfactionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      portalDialog: {
        isSelectAll: false,
        applicationList: []
      },
      ORQuestionDialog: {
        isSelectAll: false,
        applicationList: []
      },
      addCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      moveCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      removeCandidateGroupDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      exportCandidateAllInfoDialog: {
        isSelectAll: false,
        isOperator: false,
        candidateList: []
      },
      addTagDialog: {
        isSelectAll: false,
        candidateList: []
      },
      searchedGroupList: [],
      groupList: [],
      talentGroupList: [],
      isSavingSearchTemplate: false,
      location: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      major: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      school: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      expectedLocation: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      sharedTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workIndustryTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      workPositionTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      crmTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      skillTag: {
        keywords: null,
        data: null,
        loading: false,
        loader: null,
        currentData: null,
        hasLoad: false,
        page: 1,
        pageSize: 10
      },
      candidateTotalCount: 0,
      jobName: null,
      job: null,
      nps: {
        value: 0,
        nValue: 0,
        inviteCount: 0,
        rate: 0
      },
      exportInfo: {
        loading: false,
        data: [{
          id: 'All',
          get i18nName () {
            return vm.$t('common.label.selectAll')
          },
          children: []
        }]
      },
      exportPdfStatus: {
        loading: false,
        task: null,
        finished: false
      },
      exportConsentStatus: {
        loading: false,
        task: null,
        finished: false
      },
      currentSelectedCount: 0,
      search: {},
      companyPolicyList: [],
      hasProblemSolvingRequired: null,
      hasAssessmentValueRequired: null,
      hasPersonalityRequired: null,
      searchParams: null,
      isElcOriginCompany: null,
      formatBigNumber,
      statusGroupList: [],
      statusList: [],
      cancelSelectedCandidateList: [],
      isNoRefreshSelectedCandidateList: false,
      needShowAiInterview: false,
      loadResumeSDKTag: null,
      currencyList: [],
      salaryList: [],
      industryList: [],
      candidateStatusList: [],
      isEnableRefreshAIResumeMatchTask: true,
      isOutsideTimePendingAIResumeMatchTask: false,
      refreshAIResumeMatchTaskEnableAfterDays: 0,
      aiComparisonDialog: {
        show: false,
        aiComparisonLoading: false,
        loading: false,
        categories: [],
        comparisonResultList: [],
        applicationList: []
      },
      aiComparisonHistoryDialog: {
        show: false,
        jobId: null
      },
      jobAIInterviewRoomId: null,
      createJobCriterionConfirmDialog: {
        show: false,
        loading: false
      },
      createRefreshAIResumeMatchTaskDialog: {
        show: false,
        loading: false,
        content: null
      },
      tagMap: {},
      metaIndustryList: [],
      metaJobFunctionList: []
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount', 'accountConfig']),
    jobId () {
      return this.$route.params.jobId
    },
    hasCopyCandidatePermission () {
      return this.hasAnyPermission(['PREMIUM_COPY_CANDIDATE', 'PERM_HM_APPLY_JOB_FOR_CANDIDATE'])
    },
    hasInviteHMPermission () {
      return this.hasAnyPermission(['PREMIUM_INVITE_HM_REVIEW', 'PERM_INVITE_HM_REVIEW'])
    },
    hasInterviewPermission () {
      return this.hasAnyPermission(['PREMIUM_INTERVIEW_SCHEDULING', 'PERM_HR_INTERVIEW_SCHEDULING'])
    },
    hasMicrositeCampaignPermission () {
      return this.hasAnyPermission('PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT')
    },
    hasCRMTagPermission () {
      return this.hasAnyPermission('PREMIUM_TAG_MANAGEMENT')
    },
    hasCRMPreferenceSurveyPermission () {
      return this.hasAnyPermission('PREMIUM_PREFERENCE_SURVEY_MANAGEMENT')
    },
    hasParseResumeTagPermission () {
      return this.hasAnyPermission('PREMIUM_CRM_PARSE_RESUME_SDK_TAG')
    },
    hasEmployeeApplyPermission () {
      return this.hasAnyPermission({
        strict: false,
        any: [
          'PREMIUM_REFERRAL_EMPLOYEE_APPLY_INTERNAL_JOB',
          'COMPUTED_COMPANY_HAS_APPLICATION_OR_EMPLOYEE_PULL_INTEGRATION'
        ]
      })
    },
    currentAccount () {
      return this.getCurrentAccount
    },
    hasExportConsentPermission () {
      return this.currentAccount?.root_company_id === 8223
    },
    hadAddCandidatePermission () {
      return this.hasAnyPermission(['PERM_JOB_CANDIDATE_UPLOAD', 'PREMIUM_CANDIDATE_UPLOAD'])
    },
    hasPostApplicantPermission () {
      return this.hasAnyPermission('PREMIUM_POST_APPLICANT')
    },
    hasInviteORQuestionPermission () {
      return this.isElcOriginCompany
    },
    hasInviteOnboardingPermission () {
      return this.hasAnyPermission('PREMIUM_ONBOARDING')
    },
    hasSatisfactionSurveyPermission () {
      return this.hasAnyPermission(['PREMIUM_SATISFACTION_SURVEY_CANDIDATE', 'PERM_SATISFACTION_SURVEY_MANAGE'])
    },
    hasAllowEmployeeApplicationPermission () {
      return this.hasAnyPermission('PREMIUM_REFERRAL_EMPLOYEE_APPLY_INTERNAL_JOB')
    },
    hasPrescreenSurvey () {
      return this.hasAnyPermission('PREMIUM_CHATBOT_PRESCREEN_SURVEY_MANAGEMENT')
    },
    hasAssessmentPermission () {
      return this.hasAnyPermission('PREMIUM_ASSESSMENTS')
    },
    hasSoftUserPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasLeadsPermission () {
      return this.hasAnyPermission('PREMIUM_SOFT_USER')
    },
    hasAIResumeMatchPermission () {
      return this.hasAnyPermission('PREMIUM_AI_RESUME_MATCH')
    },
    canViewAIFitScore () {
      return this.hasAnyPermission(['PREMIUM_AI_RESUME_MATCH', 'PERM_HR_VIEW_AI_FIT_SCORE'])
    },
    hasAIComparisonPermission () {
      return this.hasAnyPermission('PREMIUM_AI_COMPARISON')
    },
    hasAITalentRecommendedPermission () {
      return this.hasAnyPermission('PREMIUM_AI_TALENT_RECOMMENDED')
    },
    hasOnlyActionOnMyCandidatePermission () {
      return this.hasAnyPermission('PERM_ONLY_ACTION_ON_MY_CANDIDATE')
    },
    noAction () {
      return this.hasOnlyActionOnMyCandidatePermission && !this.job?.is_my_job
    },
    tooltip () {
      return this.noAction ? this.$t(`${this.i18nPrefix}.message.disabledActionCandidateInJob`) : null
    },
    hasAIInterviewPermission () {
      return this.hasAnyPermission('PREMIUM_AI_INTERVIEW')
    },
    hasCompanyPolicy () {
      return this.companyPolicyList.length > 0
    },
    showProblemSolvingFit () {
      return this.hasAssessmentPermission && this.hasProblemSolvingRequired
    },
    showAssessmentFit () {
      return this.hasAssessmentPermission && this.hasAssessmentValueRequired
    },
    hasAISearchPermission () {
      return this.hasAnyPermission(['PERM_AI_CHAT_SEARCH', 'PREMIUM_AI_CHAT_SEARCH'])
    },
    hasAICandidateSearchFilterPermission () {
      return this.hasAnyPermission('PREMIUM_AI_CANDIDATE_SEARCH_FILTER')
    },
    applicantCountGroup () {
      const result = []
      _.forEach(STATUS_STAGE, (group, key) => {
        const groupInfo = this.getStatusInfo(group)
        const newGroupInfo = {
          count: formatBigNumber(groupInfo.count),
          name: _.lowerCase(key),
          label: this.$t(`${this.i18nPrefix}.label.${key}`),
          statusList: groupInfo.statusList
        }
        result.push(newGroupInfo)
      })
      return result
    },
    actionList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.changeStatus`),
          handler: this.handleChangeStatusAction
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteAgreeConsent`),
          handler: this.handleInviteAgreeConsent
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidates`),
          handler: this.handleCopyCandidateAction
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.contact`),
        handler: this.handleContactAction
      })
      if (this.hasInviteHMPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteHMRating`),
          handler: this.handleInviteHMRatingAction
        })
      }
      if (this.hasInterviewPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteInterview`),
          handler: this.handleInviteInterviewAction
        })
      }
      if (this.hasSendOfferPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.sendOffer`),
          handler: this.handleSendOfferAction
        })
      }
      if (this.hasAIInterviewPermission && this.jobAIInterviewRoomId) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteAIInterview`),
          handler: this.handleInviteAIInterviewAction
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerQuestion`),
        handler: this.handleInviteQuestionAction
      })
      if (this.hasInviteOnboardingPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteOnboarding`),
          handler: this.handleInviteOnboardingAction
        })
      }
      if (this.hasSatisfactionSurveyPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteSatisfactionSurvey`),
          handler: this.handleInviteSatisfactionAction
        })
      }
      if (this.hasPostApplicantPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.invitePostApplicant`),
          handler: this.handleInvitePortalAction
        })
      }
      if (this.hasInviteORQuestionPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerORQuestion`),
          handler: this.handleInviteAnswerORQuestionAction
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.group`),
        hasChildren: true,
        childrenMenuList: [
          {
            label: this.$t('admin.application.candidateGroup.title.add'),
            handler: this.openAddGroupDialog
          },
          {
            label: this.$t('admin.application.candidateGroup.title.move'),
            handler: this.openMoveGroupDialog
          },
          {
            label: this.$t('admin.application.candidateGroup.title.remove'),
            handler: this.openRemoveGroupDialog
          }
        ]
      })
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
        hasChildren: true,
        childrenMenuList: [
          {
            label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
            handler: this.handleExportCandidateAllInfo
          },
          {
            label: this.$t('admin.application.candidate.btn.exportOriginResume'),
            handler: this.handleExportOriginalResume
          },
          {
            label: this.$t('admin.application.candidate.btn.resume'),
            handler: this.handleExportResume
          },
          {
            label: this.$t('admin.application.candidate.btn.report'),
            hidden: !this.showAssessmentFit,
            handler: this.handleExportReport
          },
          {
            label: this.$t('admin.application.candidate.btn.resumeAndReport'),
            hidden: !this.showAssessmentFit,
            handler: this.handleExportResumeAndReport
          },
          {
            hidden: !this.hasExportConsentPermission,
            label: this.$t('admin.application.candidate.btn.exportConsentInfo'),
            handler: this.handleExportConsentInfo
          }
        ]
      })
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          handler: this.handleAddTagDialog
        })
      }
      if (this.hasAssessmentPermission) {
        list.push(
          {
            label: this.$t(`${this.i18nPrefix}.btn.action.inviteValueAndStrengthLabel`),
            handler: this.handleInvitePersonalityAction
          },
          {
            label: this.$t(`${this.i18nPrefix}.btn.action.inviteProblemSolveLabel`),
            handler: this.handleInviteProblemSolveAction
          }
        )
      }
      return list
    },
    aiAnalysisActionList () {
      const list = []
      if (this.canViewAIFitScore) {
        // AI Resume Match
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.createAIResumeMatch`),
          handler: this.handleCreateAIResumeMatch
        }, {
          label: this.$t(`${this.i18nPrefix}.btn.action.candidateAIMatchTable`),
          handler: this.handleToEditJobAIMatch
        })
      }
      if (this.hasAIComparisonPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.createAIComparison`),
          handler: this.handleCreateApplicationAIComparison
        }, {
          label: this.$t(`${this.i18nPrefix}.btn.action.viewAIComparisonHistory`),
          handler: this.handleViewApplicationAIComparisonHistory
        }, {
          label: this.$t(`${this.i18nPrefix}.btn.action.candidateAIComparisonTable`),
          handler: this.handleToEditJobAIComparison
        })
      }
      if (this.hasAITalentRecommendedPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.generateAIRecommendation`),
          handler: this.handleTalentPoolAIRecommended
        })
      }
      // 刷新ai匹配放到最后
      if (this.canViewAIFitScore) {
        const vm = this
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.refreshAllCandidateAIResumeMatch`),
          handler: this.handleRefreshAIResumeMatch,
          get disabled () {
            return !vm.candidateList.length || !vm.isEnableRefreshAIResumeMatchTask
          },
          get tip () {
            if (this.isOutsideTimePendingAIResumeMatchTask) {
              return vm.$t(`${this.i18nPrefix}.label.refreshAllCandidateAIResumeMatchContent`)
            }
            return vm.candidateList.length ? this.$t(`${this.i18nPrefix}.message.refreshAIResumeMatchError`, { day: this.refreshAIResumeMatchTaskEnableAfterDays || 1 }) : null
          }
        })
      }
      return list
    },
    addBtnList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.single`),
          childrenMenuList: [
            {
              label: this.$t('admin.application.candidate.label.switchFullResume'),
              handler: this.handleUploadCandidateAction
            },
            {
              label: this.$t('admin.application.candidate.label.switchMiniResume'),
              handler: this.handleUploadCandidateBasicInfoAction
            }
          ]
        },
        {
          label: this.$t(`${this.i18nPrefix}.btn.uploadCandidate.batch`),
          handler: this.handleBatchUploadCandidateAction
        }
      ]
      return this.hadAddCandidatePermission ? list : []
    },
    operationList () {
      const list = [
        {
          label: this.$t(`${this.i18nPrefix}.btn.action.changeStatus`),
          operator: this.handleChangeStatusOperation
        }
      ]
      if (this.hasCopyCandidatePermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.copyCandidate`),
          operator: this.handleCopyCandidateOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.contact`),
        operator: this.handleContactOperation
      })
      if (this.hasInviteHMPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteHMRating`),
          operator: this.handleInviteHMRatingOperation
        })
      }
      if (this.hasInterviewPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteInterview`),
          operator: this.handleInviteInterviewOperation
        })
      }
      if (this.hasSendOfferPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.sendOffer`),
          operator: this.handleSendOfferOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerQuestion`),
        operator: this.handleInviteQuestionOperation
      })
      if (this.hasInviteOnboardingPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteOnboarding`),
          operator: this.handleInviteOnboardingOperation
        })
      }
      if (this.hasSatisfactionSurveyPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteSatisfactionSurvey`),
          operator: this.handleInviteSatisfactionOperation
        })
      }
      if (this.hasPostApplicantPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.invitePostApplicant`),
          operator: this.handleInvitePortalOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.group`),
        hasChildren: true,
        childrenMenuList: [
          {
            label: this.$t('admin.application.candidateGroup.title.add'),
            operator: this.openAddGroupDialogOperation
          },
          {
            label: this.$t('admin.application.candidateGroup.title.move'),
            operator: this.openMoveGroupDialogOperation
          },
          {
            label: this.$t('admin.application.candidateGroup.title.remove'),
            operator: this.openRemoveGroupDialogOperation
          }
        ]
      })
      if (this.hasInviteORQuestionPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.inviteAnswerORQuestion`),
          operator: this.handleInviteAnswerORQuestionOperation
        })
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.talentExport`),
        childrenMenuList: [
          {
            label: this.$t(`${this.i18nPrefix}.btn.action.exportAllCandidateInfo`),
            operator: this.handleExportCandidateAllInfoOperation
          },
          {
            label: this.$t('admin.application.candidate.btn.exportOriginResume'),
            operator: this.handleExportOriginalResumeOperation
          },
          {
            label: this.$t('admin.application.candidate.btn.resume'),
            operator: this.handleExportResumeOperation
          },
          {
            label: this.$t('admin.application.candidate.btn.report'),
            hidden: !this.showAssessmentFit,
            operator: this.handleExportReportOperation
          },
          {
            label: this.$t('admin.application.candidate.btn.resumeAndReport'),
            hidden: !this.showAssessmentFit,
            operator: this.handleExportResumeAndReportOperation
          },
          {
            hidden: !this.hasExportConsentPermission,
            label: this.$t('admin.application.candidate.btn.exportConsentInfo'),
            operator: this.handleExportConsentInfoOperation
          }
        ]
      })
      if (this.hasCRMTagPermission) {
        list.push({
          label: this.$t(`${this.i18nPrefix}.btn.action.addTag`),
          operator: this.handleAddTagOperation
        })
      }
      if (this.hasAssessmentPermission) {
        list.push(
          {
            key: ASSESSMENT_INVITE_TYPE.PERSONALITY,
            label: this.$t(`${this.i18nPrefix}.btn.action.inviteValueAndStrengthLabel`),
            operator: this.handleInvitePersonalityOperation
          },
          {
            key: ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING,
            label: this.$t(`${this.i18nPrefix}.btn.action.inviteProblemSolveLabel`),
            operator: this.handleInviteProblemSolveOperation
          }
        )
      }
      list.push({
        label: this.$t(`${this.i18nPrefix}.btn.action.addComment`),
        operator: this.handleAddCommentOperation
      })
      return list
    },
    filterList () {
      const vm = this
      const filterConfig = this.accountConfig[APPLICATION_PAGE_KEY]?.filterConfig || {}
      const list = {
        [FILTER_GROUP_TYPE.ASSESSMENT_FIT]: {
          title: this.$t(`${this.i18nPrefix}.title.assessmentFit`),
          hidden: !this.hasAssessmentPermission || !this.hasAssessmentValueRequired,
          filterList: {
            assessment: {
              elType: AssessmentFitChart,
              multiple: true,
              props: {
                jobId: this.jobId
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  const assessmentFit = []
                  _.forEach(SQUARED_UP_MAP, (fit, key) => {
                    if (_.some(value, item => item.id === key)) {
                      assessmentFit.push({
                        personalityFit: fit.personalityFit,
                        cultureFit: fit.cultureFit
                      })
                    }
                  })
                  return _.map(assessmentFit, item => {
                    const { cultureFit, personalityFit } = item
                    const summary = `${this.$t(`${this.i18nPrefix}.label.cultureFit`)}: ${cultureFit[0] * 10} ~ ${cultureFit[1] * 10}
                    ${this.$t(`${this.i18nPrefix}.label.personalityFit`)}: ${personalityFit[0] * 10} ~ ${personalityFit[1] * 10}`
                    return {
                      valueKey: null,
                      value: item,
                      detail: `${group.title}: ${summary}`,
                      summary: `${summary}`
                    }
                  })
                }
              },
              setParam: (params, val) => {
                const assessmentFit = []
                _.forEach(SQUARED_UP_MAP, (fit, key) => {
                  if (_.some(val, item => item.id === key)) {
                    assessmentFit.push({
                      personalityFit: fit.personalityFit,
                      cultureFit: fit.cultureFit
                    })
                  }
                })
                params.assessment_fit = _.map(assessmentFit, item => `${item.personalityFit[0]}~${item.personalityFit[1]}_${item.cultureFit[0]}~${item.cultureFit[1]}`).join(',')
              },
              cancelSelected: (filterValue, value) => {
                filterValue.splice(_.findIndex(filterValue, { id: value.id }), 1)
                return filterValue
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROBLEM_SOLVING_FIT]: {
          hidden: !this.hasAssessmentPermission || !this.hasProblemSolvingRequired,
          title: this.$t(`${this.i18nPrefix}.title.problemSolvingFit`),
          filterList: {
            problemSolving: {
              elType: ProblemSolvingFitChart,
              multiple: true,
              props: {
                jobId: this.jobId
              },
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  return _.chain(value).filter(item => item.selected).map(item => {
                    const fitRange = PROBLEM_SOLVING_FIT_RANGE_BAR[item.name]
                    const range = fitRange ? `${fitRange[0] === -1 ? 0 : fitRange[0] * 100} ~ ${fitRange[1] === 1.1 ? 100 : fitRange[1] * 100}` : ''
                    const summary = `${this.$t(`${this.i18nPrefix}.label.problemSolvingFilter.${item.name}`)} ${range}`
                    return {
                      valueKey: null,
                      value: item,
                      detail: `${group.title}: ${summary}`,
                      summary: `${summary}`
                    }
                  }).value()
                }
              },
              setParam: (params, val) => {
                params.problem_solving_fit = _.chain(val).filter(item => item.selected).map(item => item.name).join(',').value()
              },
              cancelSelected: (filterValue, value) => {
                value.selected = false
                const index = _.findIndex(filterValue, { id: value.id })
                if (index > -1) {
                  this.$set(filterValue, index, { ...value })
                }
                return filterValue
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.SOURCE]: {
          title: this.$t(`${this.i18nPrefix}.title.source`), // 分组的标题
          hidden: false, // 是否隐藏
          filterList: {
            // example:
            // gender: { // key，标识
            //   elType: TagSelect, // 必填，元素名称或者组件
            //   label: this.$t(`${this.i18nPrefix}.label.gender`), // 必填
            //   multiple: true,
            //   fetchKey: 'gender',
            //   valueDisplay: { // 在list上面显示filter的值
            //     hidden: false, // 显示
            //     formatter (genderList, filter, filterName, group, groupKey) {
            //       return _.map(genderList, gender => {
            //         const genderLabel = _.find(GENDER, gender)
            //         return {
            //           value: gender,
            //           detail: `${group.label} - ${filter.label}: ${genderLabel}`,
            //           summary: genderLabel
            //         }
            //       })
            //     }
            //   },
            //   props: { // 组件的属性
            //     multiple: true,
            //     tagList: _.map(GENDER, (val, key) => {
            //       return {
            //         label: this.$t(`${this.i18nPrefix}.gender.${key}`),
            //         value: val
            //       }
            //     })
            //   }
            // },
            sourceChannel: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sourceChannel`),
              optionLabel: 'i18nName',
              optionValue: 'id',
              loader: this.loadSourceChannelList,
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.channel_id = _.map(val, 'id').join(',')
              }
            },
            referral: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.referral`),
              optionValue: 'value',
              optionList: _.map(REFERRAL_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.referralType.${key}`)),
              multiple: true,
              setParam: (params, val) => {
                params.referral_type = _.map(val, 'value').join(',')
              }
            },
            cvOwner: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.cvOwner`),
              optionLabel: 'name',
              optionValue: 'id',
              optionSearch: true,
              optionGroup: {},
              multiple: true,
              loader: this.loadCvOwnerList,
              setParam: (params, val) => {
                params.cv_owner = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.applicationDetail`),
          filterList: {
            appliedDate: {
              elType: DateRage,
              label: this.$t(`${this.i18nPrefix}.label.appliedDate`),
              multiple: true, // layout组件需要的值
              props: {
                align: 'center',
                format: 'yyyy-MM-dd',
                valueFormat: 'yyyy-MM-dd',
                disabledFutureDate: true
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.apply_start_time = val[0]
                if (val[1]) {
                  params.apply_end_time = moment(val[1]).add(1, 'days').format('YYYY-MM-DD')
                }
              }
            },
            candidateStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateStatus`),
              optionList: this.candidateStatusList,
              optionLabel: 'i18nName',
              optionValue: 'key',
              multiple: true,
              optionSearch: true,
              enableExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'candidate_status'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
              }
            },
            applicationStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.applicationStatus`),
              optionValue: 'value',
              optionList: _.map(APPLICATION_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.APPLICATION_STATUS.${key}`)),
              setParam: (params, val) => {
                params.application_status = val?.value
              }
            },
            group: {
              elType: GroupSelect,
              label: this.$t(`${this.i18nPrefix}.label.group`),
              props: {
                groupList: this.groupList
              },
              events: {
                saveEditGroup: this.handleSaveEditGroup,
                deleteGroup: this.handleDeleteGroup
              },
              optionValue: 'text',
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value || value.length < 1) {
                    return
                  }
                  return _.map(value, (item, index) => {
                    return {
                      valueKey: index,
                      value: item,
                      detail: `${group.title} - ${filter.label}: ${item.text}`,
                      summary: `${item.text}`
                    }
                  })
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.id !== value.id)
                return filterValue
              },
              setParam: (params, val) => {
                const groups = []
                _.forEach(val, group => {
                  groups.push(group.id)
                })
                params.group_ids = groups.join(',')
              }
            },
            readStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.readStatus`),
              optionValue: 'value',
              optionList: _.map(READ_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.READ_STATUS.${key}`)),
              setParam: (params, val) => {
                params.is_viewed = val?.value
              }
            },
            contactStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.contactStatus`),
              optionValue: 'value',
              optionList: _.map(CONTACT_STATUS, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.contactStatus.${key}`)),
              setParam: (params, val) => {
                params.has_contacted = val?.value
              }
            },
            recruiterQuestionnaire: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.recruiterQuestionnaire`),
              loader: this.loadRecruiterQuestionnaire,
              multiple: true,
              optionSearch: true,
              optionLabel: 'description',
              optionValue: 'id',
              optionGroup: {
                labelKey: 'title',
                dataKey: 'options'
              },
              setParam: (params, val) => {
                params.recruiter_survey_answer_ids = _.map(val, 'id').join(',')
              }
            },
            candidateType: {
              hidden: !this.hasEmployeeApplyPermission,
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.candidateType`),
              optionValue: 'value',
              optionList: _.map(CANDIDATE_TYPE, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.candidateType.${key}`)),
              setParam: (params, val) => {
                params.candidate_type = val?.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EMPLOYER]: {
          title: this.$t(`${this.i18nPrefix}.title.employer`),
          filterList: {
            workCompanyName: {
              elType: WorkCompanyName,
              label: null,
              multiple: true,
              valueDisplay: {
                formatter: (value, filter, filterName, group, groupKey) => {
                  if (!value) {
                    return
                  }
                  const nameList = _.isArray(value.name) ? value.name : [value.name]
                  return _.map(nameList, name => ({
                    valueKey: name,
                    value: name,
                    detail: `${group.title} - ${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`,
                    summary: `${this.$t(`${this.i18nPrefix}.label.workCompanyName`)}: ${name}`
                  }))
                }
              },
              cancelSelected: (filterValue, value) => {
                filterValue.name = null
                filterValue.isLastWork = true
                return filterValue
              },
              setParam: (params, val) => {
                const name = _.isArray(val.name) ? _.join(val.name, ';') : val.name
                if (val.isLastWork) {
                  params.last_work_company_name = name
                } else {
                  params.work_company_name = name
                }
              }
            },
            companyLevelTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.companyLevelTag`),
              label: this.$t(`${this.i18nPrefix}.label.companyLevelTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.COMPANY_LEVEL, true)
                const companyLevel = this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE][RESUME_SDK_TAG_KEYS.COMPANY_LEVEL]
                return _.orderBy(companyLevel, [item => COMPANY_LEVEL_ORDER_LIST.indexOf(item.cn_name)], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.company_level_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.JOB_TITLE]: {
          title: this.$t(`${this.i18nPrefix}.title.jobTitle`),
          filterList: {
            lastWorkJobName: {
              elType: 'el-input',
              label: this.$t(`${this.i18nPrefix}.label.lastWorkJobName`),
              setParam: (params, val) => {
                params.last_work_job_name = val
              }
            },
            workPositionTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workPositionTag`),
              optionList: this.tagMap[RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE]?.[RESUME_SDK_TAG_KEYS.POSITION],
              hidden: !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workPositionTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.POSITION)
              },
              initData: () => {
                return this.initSelectData(this.workPositionTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workPositionTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workPositionTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workPositionTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workPositionTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_position_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.INDUSTRY]: {
          title: this.$t(`${this.i18nPrefix}.title.industry`),
          filterList: {
            workIndustryTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.workIndustryTag`),
              hidden: this.hasAICandidateSearchFilterPermission || !this.hasParseResumeTagPermission,
              loader: () => {
                return this.initTagList(this.workIndustryTag, 'system', RESUME_SDK_TAG_TYPES.WORK_EXPERIENCE, RESUME_SDK_TAG_KEYS.INDUSTRY)
              },
              initData: () => {
                return this.initSelectData(this.workIndustryTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.workIndustryTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.workIndustryTag, filter)
              },
              props: {
                popperClass: 'work-industry-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.workIndustryTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.workIndustryTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.work_industry_tag = _.map(val, 'id').join(',')
              }
            },
            // lastWorkIndustry: {
            //   elType: 'el-select',
            //   label: this.$t(`${this.i18nPrefix}.label.lastWorkIndustry`),
            //   optionList: this.industryList,
            //   optionLabel: 'i18nName',
            //   optionValue: 'id',
            //   multiple: true,
            //   optionSearch: true,
            //   setParam: (params, val) => {
            //     params.last_work_industry = _.map(val, 'id').join(',')
            //   }
            // },
            metaIndustry: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaIndustry`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaIndustryList,
              optionGroup: {
                labelKey: 'i18nName'
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_industry_id = _.map(val, 'id').join(',')
              }
            },
            metaJobFunction: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.metaJobFunction`),
              hidden: !this.hasAICandidateSearchFilterPermission,
              loader: this.loadMetaJobFunctionList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              // labelContainer: {
              //   flex: this.hasAISearchPermission,
              //   showUseAiSwitch: this.hasAISearchPermission
              // }, 暂不需要
              setParam: (params, val) => {
                params.meta_job_function_id = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.SKILL]: {
          title: this.$t(`${this.i18nPrefix}.title.skill`),
          filterList: {
            skillTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.skillTag`),
              hidden: !this.hasParseResumeTagPermission,
              loader: this.resetSkillTag,
              optionSearch: (keywords, loadData, valueList) => {
                return this.loadSkillTagList(keywords, valueList)
              },
              loadTemplate: this.loadSkillTagTemplate,
              filterMethod: this.filterSkillTagMethod,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.skillTag, filter)
              },
              selectAll: {
                getOptions: this.getSkillTagSelectAllOptions
              },
              props: {
                collapseTags: true,
                popperClass: 'hard-skill-popper',
                get noDataText () {
                  return vm.getSkillTagNoDataText()
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    this.resetSkillTag(filter)
                  }
                }
              },
              setParam: (params, val) => {
                params.skill_tag = _.map(val, 'id').join(',')
              }
            },
            language: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.language`),
              loader: this.loadLanguageList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              optionSearch: true,
              multiple: true,
              setParam: (params, val) => {
                params.language = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.EDUCATION]: {
          title: this.$t(`${this.i18nPrefix}.title.education`),
          filterList: {
            graduateYear: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.graduateYear`),
              optionList: GRADUATION_YEAR_OPTION_LIST,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.graduate_year = _.map(val, 'id').join(',')
              }
            },
            maxDegree: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.maxDegree`),
              optionList: _.map(DEGREE, (val, key) => createI18nProperty({ id: val }, 'i18nName', `meta.DEGREE.${key}`)),
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              setParam: (params, val) => {
                params.max_degree = _.map(val, 'id').join(',')
              }
            },
            school: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.school`),
              loader: this.initSchoolList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: this.loadSchoolList,
              optionTooltip: true,
              loadMore: (filter) => {
                this.loadMoreData(this.school, filter)
              },
              props: {
                popperClass: 'school-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.school)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                params.school_id = _.map(val, 'id').join(',')
              }
            },
            schoolTier: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.schoolTier`),
              label: this.$t(`${this.i18nPrefix}.label.schoolTier`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL, true)
                return _.reverse(this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.COLLEGE_LEVEL])
              },
              hidden: !this.hasParseResumeTagPermission,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.college_level_tag = _.map(val, 'id').join(',')
              }
            },
            major: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.major`),
              loader: this.initMajorList,
              multiple: true,
              optionValue: 'id',
              optionLabel: 'i18nName',
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.major, keywords, loadData, valueList)
              },
              loadMore: (filter) => {
                this.loadMoreData(this.major, filter)
              },
              props: {
                popperClass: 'major-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.major)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = []
                  }
                }
              },
              setParam: (params, val) => {
                params.major_ids = _.map(val, 'id').join(',')
              }
            },
            foreignEducationExperience: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.foreignEducationExperience`),
              hidden: !this.hasParseResumeTagPermission,
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.EDUCATION, RESUME_SDK_TAG_KEYS.ABROAD_EDU, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.EDUCATION][RESUME_SDK_TAG_KEYS.ABROAD_EDU]
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              props: { collapseTags: true },
              setParam: (params, val) => {
                params.abroad_edu_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.PROFILE_DETAIL]: {
          title: this.$t(`${this.i18nPrefix}.title.profileDetail`),
          filterList: {
            workYear: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.workYear`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: _.chain(0).range(16).map(year => {
                  return {
                    label: year >= 15 ? '15+' : year,
                    value: year
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.work_year_min = val[0]
                params.work_year_max = val[1]
              }
            },
            gender: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.gender`),
              multiple: true,
              optionValue: 'value',
              optionList: _.map(GENDER, (val, key) => createI18nProperty({ value: val }, 'label', `${this.i18nPrefix}.gender.${key}`)),
              setParam: (params, val) => {
                params.gender = _.map(val, 'value').join(',')
              }
            },
            age: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.age`),
              multiple: true,
              props: {
                clearable: true,
                optionList: _.chain(18).range(100).map(age => {
                  return {
                    label: age >= 100 ? '100+' : age,
                    value: age
                  }
                }).value()
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.age_min = val[0]
                params.age_max = val[1]
              }
            },
            location: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.location`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              filterMethod: this.filterLocationMethod,
              optionSearch: this.loadLocationList,
              loadTemplate: this.loadLocationTemplate,
              loader: this.getLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.location, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.location)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.location_country_id = _.map(group.country, 'id').join(',')
                params.location_province_id = _.map(group.district, 'id').join(',')
                params.location_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedLocation: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.expectedLocation`),
              optionLabel: 'locationName',
              optionValue: 'id',
              multiple: true,
              optionSearch: this.loadExpectedLocationList,
              loadTemplate: this.loadExpectedLocationTemplate,
              loader: this.getExpectedLocationList,
              loadMore: (filter) => {
                this.loadMoreData(this.expectedLocation, filter)
              },
              props: {
                popperClass: 'location-dropdown',
                get noDataText () {
                  return vm.getNoDataText(vm.expectedLocation)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible) {
                    if (filter) {
                      filter.option.data = []
                    }
                  }
                }
              },
              setParam: (params, val) => {
                const group = _.groupBy(val, 'type_code')
                // 处理直辖市
                const municipalityCityIds = []
                _.forEach(group.district, location => {
                  const cityName = _.findKey(MUNICIPALITY_PROVINCE, city => city === location.id)
                  if (cityName) {
                    municipalityCityIds.push(MUNICIPALITY_CITY[cityName])
                  }
                })

                params.expected_country_id = _.map(group.country, 'id').join(',')
                params.expected_province_id = _.map(group.district, 'id').join(',')
                params.expected_city_id = [..._.map(group.city, 'id'), ...municipalityCityIds].join(',')
              }
            },
            expectedSalary: {
              elType: RangeSelect,
              label: this.$t(`${this.i18nPrefix}.label.expectedSalary`),
              multiple: true,
              optionSearch: true,
              props: {
                clearable: true,
                optionList: this.salaryList,
                optionLabelKey: 'name',
                optionValueKey: 'name'
              },
              cancelSelected: this.cancelRangeFilterValue,
              valueDisplay: {
                formatter: this.formatRangeFilterDisplayValue
              },
              setParam: (params, val) => {
                if (!val) {
                  return
                }
                params.salary_min = val[0]
                params.salary_max = val[1]
              }
            },
            consentStatus: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.consentStatus`),
              multiple: true,
              hidden: !this.hasCompanyPolicy,
              optionList: this.companyPolicyList,
              optionLabel: 'i18nName',
              optionValue: 'value',
              optionSearch: true,
              optionTooltip: true,
              optionGroup: {
                labelKey: 'i18nName',
                valueKey: 'value',
                dataKey: 'status_list'
              },
              props: {
                popperClass: 'consent-info-popper'
              },
              valueDisplay: {
                formatter: this.formatConsentFilterDisplayValue
              },
              cancelSelected: (filterValue, value) => {
                filterValue = _.filter(filterValue, item => item.value !== value)
                return filterValue
              },
              setParam: (params, val) => {
                const option = []
                _.forEach(val, policy => {
                  option.push(policy.value)
                })
                params.consent_status = option.join(',')
              }
            },
            hasPhone: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.hasPhone`),
              optionList: [
                { get label () { return vm.$t('common.label.yes') }, value: '1' },
                { get label () { return vm.$t('common.label.no') }, value: '0' }
              ],
              optionLabel: 'label',
              optionValue: 'value',
              setParam: (params, val) => {
                params.has_phone = val.value
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CRM_TAG]: {
          title: this.$t(`${this.i18nPrefix}.title.crmTag`),
          filterList: {
            crmTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.crmTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initCRMTagList(this.crmTag)
              },
              initData: () => {
                return this.initSelectData(this.crmTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.crmTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              enableExclude: true,
              loadMore: (filter) => {
                this.loadMoreData(this.crmTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.crmTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.crmTag, 2)
                  }
                }
              },
              setParam: (params, val, isExclude) => {
                let paramKey = 'tag_id'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, 'id').join(',')
                params.is_match_all_tag = '0'
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_BEHAVIOR]: {
          title: this.$t(`${this.i18nPrefix}.title.candidateBehavior`),
          filterList: {
            sharedTag: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.sharedTag`),
              hidden: !this.hasCRMTagPermission,
              loader: () => {
                return this.initTagList(this.sharedTag, 'system', CRM_TAG_TYPES.SHARED)
              },
              initData: () => {
                return this.initSelectData(this.sharedTag, 2)
              },
              optionSearch: (keywords, loadData, valueList) => {
                return this.searchItemList(this.sharedTag, keywords, loadData, valueList)
              },
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              loadMore: (filter) => {
                this.loadMoreData(this.sharedTag, filter)
              },
              props: {
                collapseTags: true,
                popperClass: 'shared-tag-popper',
                get noDataText () {
                  return vm.getNoDataText(vm.sharedTag)
                }
              },
              events: {
                'visible-change': (visible, filterName, filter) => {
                  if (visible && filter) {
                    filter.option.data = this.initSelectData(this.sharedTag, 2)
                  }
                }
              },
              setParam: (params, val) => {
                params.crm_shared_tag = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.CANDIDATE_PREFERENCE]: {
          title: this.$t(`${this.i18nPrefix}.title.candidatePreferences`),
          filterList: {
            candidateSurveyQuestions: {
              elType: 'el-select',
              hidden: !this.hasCRMPreferenceSurveyPermission,
              label: this.$t(`${this.i18nPrefix}.label.candidateSurveyQuestions`),
              loader: this.loadCandidateSurveyQuestionList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              optionGroup: {
                labelKey: 'i18nName',
                dataKey: 'answer'
              },
              setParam: (params, val) => {
                const candidateSurveyQuestions = []
                _.forEach(val, option => {
                  candidateSurveyQuestions.push({ question_id: option.questionId, option_id: option.id, option_type: option.option_type })
                })
                if (candidateSurveyQuestions.length < 1) {
                  return
                }
                params.candidate_survey_questions = JSON.stringify(candidateSurveyQuestions)
              }
            },
            employeeSurveyQuestions: {
              elType: 'el-select',
              hidden: !this.hasCRMPreferenceSurveyPermission,
              label: this.$t(`${this.i18nPrefix}.label.employeeSurveyQuestions`),
              loader: this.loadEmployeeSurveyQuestionList,
              optionLabel: 'i18nName',
              optionValue: 'id',
              multiple: true,
              optionSearch: true,
              optionGroup: {
                labelKey: 'i18nName',
                dataKey: 'answer'
              },
              setParam: (params, val) => {
                const employeeSurveyQuestions = []
                _.forEach(val, option => {
                  employeeSurveyQuestions.push({ question_id: option.questionId, option_id: option.id, option_type: option.option_type })
                })
                if (employeeSurveyQuestions.length < 1) {
                  return
                }
                params.employee_survey_questions = JSON.stringify(employeeSurveyQuestions)
              }
            },
            applicationQuestionnaire: {
              elType: 'el-select',
              label: this.$t(`${this.i18nPrefix}.label.applicantQuestionnaire`),
              loader: this.loadApplicationQuestionnaire,
              multiple: true,
              optionSearch: true,
              optionLabel: 'description',
              optionValue: 'id',
              optionGroup: {
                labelKey: 'title',
                dataKey: 'options'
              },
              setParam: (params, val) => {
                params.application_survey_answer_ids = _.map(val, 'id').join(',')
              }
            },
            prescreenQuestionnaire: {
              elType: 'el-select',
              hidden: !this.hasPrescreenSurvey,
              label: this.$t(`${this.i18nPrefix}.label.prescreenQuestionnaire`),
              loader: this.loadPrescreenQuestionnaire,
              multiple: true,
              optionSearch: true,
              optionLabel: 'description',
              optionValue: 'id',
              optionGroup: {
                labelKey: 'title',
                dataKey: 'options'
              },
              setParam: (params, val) => {
                params.prescreen_survey_answer_ids = _.map(val, 'id').join(',')
              }
            }
          }
        },
        [FILTER_GROUP_TYPE.OTHER_FACTOR]: {
          title: this.$t(`${this.i18nPrefix}.title.otherFactors`),
          filterList: {
            stabilityTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.stabilityTag`),
              label: this.$t(`${this.i18nPrefix}.label.stabilityTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.STABILITY, null, true)
                return _.orderBy(this.tagMap[RESUME_SDK_TAG_TYPES.STABILITY], ['order'], ['asc'])
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              setParam: (params, val) => {
                params.stability_tag = _.map(val, item => item.id).join(',')
              }
            },
            riskTag: {
              elType: 'el-select',
              labelSlot: 'filterTip',
              tip: this.$t(`${this.i18nPrefix}.tip.riskTag`),
              label: this.$t(`${this.i18nPrefix}.label.riskTag`),
              loader: async () => {
                await this.loadTagList('system', RESUME_SDK_TAG_TYPES.RISKS, null, true)
                return this.tagMap[RESUME_SDK_TAG_TYPES.RISKS]
              },
              hidden: !this.hasParseResumeTagPermission,
              multiple: true,
              optionLabel: 'i18nName',
              optionValue: 'id',
              props: {
                collapseTags: true,
                filterable: true
              },
              enableExclude: true,
              defaultExclude: true,
              setParam: (params, val, isExclude) => {
                let paramKey = 'risks_tag'
                if (isExclude) {
                  paramKey += '__not'
                }
                params[paramKey] = _.map(val, item => item.id).join(',')
              }
            }
          }
        }
      }
      _.forEach(list, (value, key) => {
        value.defaultExpand = filterConfig[key] || false
      })
      return list
    },
    candidateListLength () {
      return this.candidateList.length
    },
    selectAllIsIndeterminate () {
      if (this.currentSelectedCount && (this.currentSelectedCount !== this.candidateTotalCount)) {
        return true
      }
      return false
    }
  },
  created () {
    this.pageDataLoader = this.initPageData()
  },
  mounted () {
    this.pageDataLoader.finally(() => {
      this.initNpsChart()
      this.$eventBus.$emit('showLoading', false)
    }).then(() => {
      const onlyUseStatus = this.$route.query.only_use_status === '1'
      const candidateStatus = this.$route.query.candidate_status
      let readStatus
      if (!onlyUseStatus) {
        readStatus = this.$route.query.read_status
      }
      this.listLoading = true
      const applicationDetailSearch = {
        candidateStatus: candidateStatus ? candidateStatus.split(',') : ['Disqualified'],
        readStatus: readStatus?.split(',')
      }
      if (!candidateStatus) {
        applicationDetailSearch._exclude = ['candidateStatus']
      }
      const search = {
        [FILTER_GROUP_TYPE.APPLICATION_DETAIL]: applicationDetailSearch
      }
      return this.$refs.filterList.resetSearch({ search }, true)
    }).then((search) => {
      if (this.$refs.filterList) {
        this.$refs.filterList.noTriggerSearch = false
      }
      return this.handelSearch(search)
    }).finally(() => {
      this.listLoading = false
    })
  },
  methods: {
    ...mapActions('sourceCode', ['getSourceChannelList']),
    ...mapActions('worldLocation', ['getWorldLocationList']),
    ...mapActions('application', [
      'getLanguageList',
      'getSchoolList',
      'getJobApplicationList',
      'getMajorList',
      'getRecruiterQuestionnaire',
      'getApplicationQuestionnaire',
      'getPrescreenQuestionnaire',
      'getGroupList',
      'createGroup',
      'saveCandidateGroup',
      'updateGroup',
      'deleteGroup',
      'moveCandidateGroup',
      'removeCandidateFromGroup',
      'getExportJobApplicationExcelFieldInfo',
      'createExportJobApplicationExcelInfoTask',
      'exportCandidateProfilePdf',
      'getExportCandidateProfilePdfTaskStatus',
      'getExportConsentPDFaskStatus',
      'exportConsentPDF',
      'sendInviteAnswerOriginCompanyQuestion',
      'getCandidateStatusGroupList',
      'sendInviteNotification',
      'getSalaryList',
      'getIndustryList',
      'exportOriginalResume'
    ]),
    ...mapActions('candidateStatus', ['getCandidateStatusList']),
    ...mapActions('account', [
      'getAccountPageConfigList',
      'createAccountPageConfig',
      'updateAccountPageConfig',
      'deleteAccountPageConfig',
      'setAccountConfig'
    ]),
    ...mapActions('survey', ['getCompanySurveyQuestionList']),
    ...mapActions('job', ['getJobInfo', 'getJobCriterionList', 'createJobCriterionByParseJob']),
    ...mapActions('interview', ['getJobInterviewRoomInfo', 'inviteAIInterview']),
    ...mapActions('agreement', ['getCompanyPolicyItemList', 'inviteCandidateAgreeConsent']),
    ...mapActions('company', ['getCvOwnerList']),
    ...mapActions('ai', ['createAIResumeMatch', 'createAIComparison', 'getAIComparisonInfoByTaskId', 'getAIComparisonHistoryInfoById']),
    ...mapActions('crm', ['searchTag']),
    ...mapActions('jobFit', ['getRefreshJobFitTask', 'createRefreshJobFitTask']),
    ...mapActions('metaInfo', ['getMetaIndustryList', 'getMetaJobFunctionList']),
    initNpsChart () {
      if (!this.hasSatisfactionSurveyPermission) {
        return
      }

      let value = this.nps.value
      const color = getScoreColor(value)
      let name = `${value}%`
      if (!this.nps.value && value !== 0) {
        name = 'N/A'
      }
      const clockwise = value >= 0
      value = Math.abs(value)
      const option = generateFitEchartsOption(name, value, color, '14px', '#606266', '#DCDFE6', 3)
      option.series.clockwise = clockwise
      const npsChart = echarts.init(this.$refs.npsChart)
      npsChart.setOption(option)
    },
    getStatusInfo (status) {
      return _.find(this.job.statusCountGroup, ['name', status])
    },
    initCandidateStatusCount (jobObj) {
      const statusGroup = jobObj.group_info_list
      const applicantInfo = jobObj.applicant_info
      const statusCountGroup = []
      _.forEach(statusGroup, (group) => {
        let groupCount = 0
        _.forEach(group.status_list, (status) => {
          const statusCount = applicantInfo[status.key] || 0
          groupCount += statusCount
          status.count = statusCount
          addI18nProperty(status, 'label', 'name_cn', 'name_en')
        })
        statusCountGroup.push({ name: group.name, statusList: group.status_list, count: groupCount })
      })
      jobObj.statusCountGroup = statusCountGroup
    },
    formatRangeFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValue = {
        valueKey: -1,
        value: null,
        summary: null,
        get detail () {
          return `${group.title} - ${this.summary}`
        }
      }
      const startVal = value[0]
      const endVal = value[1]
      const nilVal = [null, undefined, '']
      if (!nilVal.includes(startVal) && !nilVal.includes(endVal)) {
        displayValue.valueKey = -1
        displayValue.value = value
        displayValue.summary = `${filter.label}: ${startVal} ~ ${endVal}`
      } else if (!nilVal.includes(startVal)) {
        displayValue.valueKey = 0
        displayValue.value = value
        displayValue.summary = `${filter.label}: > ${startVal}`
      } else if (!nilVal.includes(endVal)) {
        displayValue.valueKey = 1
        displayValue.value = value
        displayValue.summary = `${filter.label}: < ${endVal}`
      }
      return displayValue
    },
    cancelRangeFilterValue (filterValue, value, valueKey) {
      if (valueKey < 0) {
        return []
      } else {
        return _.map(filterValue, (val, index) => valueKey === index ? null : val)
      }
    },
    handleSelectedChange (val) {
      this.selectedCandidateList = val
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      if (val.length !== this.candidateList.length) {
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.isClickSelectAll = false
      }
      if (this.isSelectedAllCandidate && this.isSelectedAllCardCandidate) {
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
      } else if (this.isSelectedAllCandidate || this.isSelectedAllCardCandidate) {
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateList.length - cancelSelectCount
      } else if (this.isClickSelectAll) {
        const cancelSelectCount = this.candidateList.length - val.length
        this.currentSelectedCount = this.candidateTotalCount - cancelSelectCount
        this.cancelSelectedCandidateList = []
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(val, candidate)) {
            this.cancelSelectedCandidateList.push(candidate)
          }
        })
      } else {
        this.currentSelectedCount = val.length
        this.isNoRefreshSelectedCandidateList = true
      }
      const cancelCandidateIds = _.map(this.cancelSelectedCandidateList, candidate => candidate.candidate.id)
      this.searchParams.cancel_candidate_ids = cancelCandidateIds.join(',')
    },
    handleSelectAllCard (selected) {
      if (selected) {
        const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
        _.forEach(this.candidateList, candidate => {
          if (!candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          }
        })
        this.isSelectedAllCandidate = true
        this.isSelectedAllCardCandidate = true
        this.currentSelectedCount = this.candidateTotalCount - hiddenCandidateList.length
        this.isClickSelectAll = true
        this.isNoRefreshSelectedCandidateList = false
      } else {
        _.forEach(this.candidateList, candidate => {
          candidate.selected = false
        })
        this.isSelectedAllCandidate = false
        this.isSelectedAllCardCandidate = false
        this.currentSelectedCount = 0
        this.isClickSelectAll = false
      }
      this.cancelSelectedCandidateList = []
    },
    handleSelectAll (selected) {
      const hiddenCandidateList = _.filter(this.candidateList, candidate => candidate.is_agency_uploaded_and_hid)
      this.isSelectedAllCandidate = selected.length > 0
      this.isClickSelectAll = selected.length > 0
      this.isNoRefreshSelectedCandidateList = !this.isSelectedAllCandidate
      this.currentSelectedCount = this.isSelectedAllCandidate ? this.candidateTotalCount - hiddenCandidateList.length : 0
      this.cancelSelectedCandidateList = []
    },
    handleUploadCandidateAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/${this.jobId}/add?back=${back}&is_basic_info=0`)
    },
    handleUploadCandidateBasicInfoAction () {
      const back = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/job/${this.jobId}/add?back=${back}&is_basic_info=1`)
    },
    handleBatchUploadCandidateAction () {
      window.open(`/v-admin/application/${this.jobId}/batch-upload/uploader`)
    },
    hasSelected () {
      if (!this.isSelectedAllCandidate && this.selectedCandidateList.length < 1) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAtLeastCandidate`))
        return false
      }
      return true
    },
    handleChangeStatusAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.changeCandidateStatusDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.changeCandidateStatusDialog.showDialog()
    },
    async handleInviteAgreeConsent () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      const data = {
        is_batch: true,
        is_all_application: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        application_ids: _.map(this.selectedCandidateList, 'id'),
        job_id: this.jobId,
        search_params: this.searchParams
      }
      try {
        const resp = await this.inviteCandidateAgreeConsent(data)
        if (resp) {
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.inviteAgreeConsent.success`)
          })
        } else {
          this.$message({
            type: 'error',
            message: this.$t(`${this.i18nPrefix}.message.inviteAgreeConsent.fail`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleChangeStatusSuccess () {
      this.loadJobInfo()
      this.handleStatusChangedSuccess()
    },
    handleInviteOpenQuestionSuccess () {
      this.handleStatusChangedSuccess()
    },
    handleInvitedOnboardingSuccess () {
      this.handleStatusChangedSuccess()
    },
    handleContactCandidateSuccess () {
      this.handleStatusChangedSuccess()
    },
    handleAddTagSuccess () {
      this.handleStatusChangedSuccess()
    },
    handleCopyCandidateAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.copyCandidateDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleInviteHMRatingAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.ratingDialog = {
        applicationList: this.selectedCandidateList,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleSentHmRatingInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.ratingDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })
      this.handleStatusChangedSuccess()
    },
    handleInviteInterviewAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.interviewDialog = {
        applicationList: this.selectedCandidateList,
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    async handleInviteAIInterviewAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const isAllApplication = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const companyId = this.selectedCandidateList[0]?.job?.company?.id ||
        this.selectedCandidateList[0]?.job?.company_id ||
        this.job?.company?.id ||
        this.job?.company_id
      if (!companyId) {
        return
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.inviteAIInterview({
          company_id: companyId,
          job_id: this.jobId,
          candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
          is_all_application: isAllApplication,
          search_params: this.searchParams
        })
        if (resp) {
          const inviteStats = resp.invite_stats || {}
          const totalCount = inviteStats.total_count || 0
          const successCount = inviteStats.success_count || 0
          const failedCount = inviteStats.failed_count || 0
          const hasInvitedCount = inviteStats.has_invited_count || 0
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.inviteAIInterviewResult`, {
              totalCount,
              hasInvitedCount,
              successCount,
              failedCount
            })
          })
          this.handleStatusChangedSuccess()
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleInviteQuestionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.questionDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteQuestionDialog.openDialog()
    },
    handleContactAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.contactDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateIds: _.map(this.selectedCandidateList, item => item.candidate.id)
      }
      this.$refs.contactDialog.openDialog()
    },
    handleInviteOnboardingAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.onboardingDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteOnboardingDialog.openDialog()
    },
    handleInviteSatisfactionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.satisfactionDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.inviteSatisfactionDialog.openDialog()
    },
    handleInvitePortalAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.portalDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        applicationList: this.selectedCandidateList
      }
      this.$refs.invitePortalDialog.openDialog()
    },
    openAddGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    async handleInviteAnswerORQuestionAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const params = {
        candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
        job_id: this.jobId,
        is_all_application: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        search_params: this.searchParams
      }
      const resp = await this.sendInviteAnswerOriginCompanyQuestion(params)
      if (resp) {
        const successCount = resp.send_success_count
        this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteORQuestion`, { inviteCount: this.selectedCandidateList.length, successCount: successCount }))
      }
    },
    openMoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    openRemoveGroupDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > 60000 || (this.isSelectedAllCandidate && this.candidateTotalCount > 60000)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.groupCandidateLimit`))
        return
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    handleSentInterviewInvite (inviteResult) {
      const changedCandidateIds = inviteResult.changed_candidate_ids
      const applicationList = this.interviewDialog.applicationList
      _.forEach(applicationList, application => {
        if (changedCandidateIds.includes(application.candidate.id)) {
          application.status = addI18nProperty(inviteResult.candidate_status, 'i18nName', 'name_cn', 'name_en')
        }
      })

      this.handleStatusChangedSuccess()
    },
    handleInvitePersonalityAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidateIds = _.map(this.selectedCandidateList, item => item.candidate.id)
      const isSelectAll = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const typeId = ASSESSMENT_INVITE_TYPE.PERSONALITY
      this.sendInviteAssessment(typeId, candidateIds, isSelectAll)
    },
    handleInviteProblemSolveAction () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidateIds = _.map(this.selectedCandidateList, item => item.candidate.id)
      const isSelectAll = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const typeId = ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING
      this.sendInviteAssessment(typeId, candidateIds, isSelectAll)
    },
    async handleCreateAIResumeMatch () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const params = {
        candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
        job_id: this.jobId,
        is_all_application: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        search_params: this.searchParams
      }
      const resp = await this.createAIResumeMatch(params)
      if (resp) {
        const hasExistsCount = resp.has_exists_count
        const successCount = resp.success_count
        this.$message({
          type: 'success',
          message: this.$t(`${this.i18nPrefix}.message.addToGenerateTaskSuccessful`, { successCount: successCount, hasExitsCount: hasExistsCount })
        })
      }
    },
    handleToEditJobAIMatch () {
      window.open(addQueryInPath(`/v-admin/job/edit/${this.jobId}`, {
        back: this.$route.fullPath,
        step: JOB_EDITOR_STEP_TYPE.BASE_INFO,
        standalone_step: JOB_EDITOR_STEP_TYPE.JOB_FIT_CONDITION
      }))
    },
    async getRefreshAIResumeMatchTaskStatus () {
      if (!this.canViewAIFitScore) {
        return false
      }
      const resp = await this.getRefreshJobFitTask(this.jobId)
      if (resp?.status === 'within_time_limit') {
        this.refreshAIResumeMatchTaskEnableAfterDays = resp.enable_after_days
        this.isEnableRefreshAIResumeMatchTask = false
      } else if (resp?.status === 'outside_time_pending') {
        // 规定时间外未完成, 提示是否重新开始
        this.isEnableRefreshAIResumeMatchTask = false
        this.isOutsideTimePendingAIResumeMatchTask = true
      }
    },
    async handleRefreshAIResumeMatch () {
      const resp = await this.getRefreshJobFitTask(this.jobId)
      if (resp) {
        const taskStatus = resp?.status
        if (taskStatus === 'outside_time_pending') {
          // 规定时间外未完成, 提示是否重新开始
          this.isEnableRefreshAIResumeMatchTask = false
          this.isOutsideTimePendingAIResumeMatchTask = true
          this.$message.error(this.$t(`${this.i18nPrefix}.label.refreshAllCandidateAIResumeMatchContent`))
          return
        }
        if (taskStatus === 'within_time_limit') {
          // 规定的时间内存在记录，不可以在点击
          this.refreshAIResumeMatchTaskEnableAfterDays = resp.enable_after_days
          this.$message.error(this.$t(`${this.i18nPrefix}.message.refreshAIResumeMatchError`, { day: this.refreshAIResumeMatchTaskEnableAfterDays || 1 }))
          this.isEnableRefreshAIResumeMatchTask = false
          return
        }
        // 提示是否确认刷新
        this.createRefreshAIResumeMatchTaskDialog.content = this.$t(`${this.i18nPrefix}.label.confirmRefreshAllCandidateAIResumeMatchContent`)
        this.createRefreshAIResumeMatchTaskDialog.show = true
      }
    },
    async handleCreateRefreshAIResumeMatchTask () {
      this.createRefreshAIResumeMatchTaskDialog.loading = true
      try {
        const resp = await this.createRefreshJobFitTask(this.jobId)
        if (resp) {
          this.isEnableRefreshAIResumeMatchTask = false
          this.$message.success(this.$t(`${this.i18nPrefix}.message.refreshAIResumeMatchSuccess`))
        }
      } finally {
        this.createRefreshAIResumeMatchTaskDialog.loading = false
        this.createRefreshAIResumeMatchTaskDialog.show = false
        this.createRefreshAIResumeMatchTaskDialog.content = null
      }
    },
    handleToEditJobAIComparison () {
      window.open(addQueryInPath(`/v-admin/job/edit/${this.jobId}`, {
        back: this.$route.fullPath,
        step: JOB_EDITOR_STEP_TYPE.BASE_INFO,
        standalone_step: JOB_EDITOR_STEP_TYPE.AI_COMPARISON_CRITERION
      }))
    },
    async loadJobCriterionList (excludeDeleted, onlyEnabled) {
      // 将 AI comparison 时使用的 categories 获取，用于显示
      const params = {
        job_id: this.jobId
      }
      // 排除被删除的 criterion
      if (excludeDeleted) {
        params.is_deleted = 0
      }
      if (onlyEnabled) {
        params.is_enabled = 1
      }
      const resp = await this.getJobCriterionList(params)
      if (resp && resp?.length) {
        const criterionList = _.chain(resp).forEach(item => addI18nProperty(item, 'i18nName', 'name_cn', 'name_en')).value()
        return criterionList
      }
    },
    async handleCreateApplicationAIComparison () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      if (candidates.length > AI_COMPARISON_CANDIDATE_LIMIT.MAX || candidates.length < AI_COMPARISON_CANDIDATE_LIMIT.MIN) {
        this.$message({
          type: 'warning',
          message: this.$t(`${this.i18nPrefix}.message.aiComparisonCountError`, { min: AI_COMPARISON_CANDIDATE_LIMIT.MIN, max: AI_COMPARISON_CANDIDATE_LIMIT.MAX }),
          duration: 5000
        })
        return
      }

      // 将 AI comparison 时使用的 categories 获取，用于显示，当生成时只使用 job 绑定的 criterion
      const resp = await this.loadJobCriterionList(true, true)
      if (resp) {
        this.aiComparisonDialog.categories = resp
      } else {
        this.createJobCriterionConfirmDialog.show = true
        return
      }

      const aiTask = {
        task: null,
        isFinished: false
      }
      this.aiComparisonDialog.comparisonResultList = []
      this.aiComparisonDialog.aiComparisonLoading = true
      this.aiComparisonDialog.loading = false
      this.aiComparisonDialog.show = true
      this.aiComparisonDialog.applicationList = this.selectedCandidateList

      const params = {
        job_id: this.jobId,
        candidate_ids: candidates
      }
      aiTask.task = new AsyncTask(() => this.createAIComparison(params), (taskId) => this.getAIComparisonInfoByTaskId(taskId), (taskId, resp) => {
        if (resp) {
          aiTask.isFinished = true
          const comparisonResultList = resp.result
          this.aiComparisonDialog.comparisonResultList = comparisonResultList
          if (!comparisonResultList?.length) {
            this.$message({
              type: 'warning',
              message: this.$t(`${this.i18nPrefix}.message.aiComparisonError`),
              duration: 5000
            })
            this.aiComparisonDialog.show = false
          }
          this.aiComparisonDialog.aiComparisonLoading = false
        }
      })
    },
    handleOpenCandidateDetail (candidateId) {
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${this.jobId}&back=${backUrl}`)
    },
    handleViewApplicationAIComparisonHistory () {
      this.aiComparisonHistoryDialog.jobId = this.jobId
      this.aiComparisonHistoryDialog.show = true
    },
    async handleViewAIComparison (historyId) {
      // 将 AI comparison 时使用的 categories 获取，用于显示, 查看时应该包含已经删除的 criterion，以为历史数据需要
      const criterionResp = await this.loadJobCriterionList()
      if (criterionResp) {
        this.aiComparisonDialog.categories = criterionResp
      } else {
        this.createJobCriterionConfirmDialog.show = true
        return
      }

      this.aiComparisonDialog.comparisonResultList = []
      this.aiComparisonDialog.aiComparisonLoading = false
      this.aiComparisonDialog.loading = true
      this.aiComparisonDialog.show = true
      this.aiComparisonDialog.applicationList = []
      try {
        const resp = await this.getAIComparisonHistoryInfoById(historyId)
        if (resp) {
          this.aiComparisonDialog.applicationList = _.map(resp.candidate_list, item => {
            return {
              candidate: item,
              get locationI18nName () {
                const location = item.location
                const province = getI18nPropertyValue(location.province, 'cn_name', 'name')
                const city = getI18nPropertyValue(location.city, 'cn_name', 'name')
                return city || province
              }
            }
          })
          this.aiComparisonDialog.comparisonResultList = resp.comparison_result
        }
      } finally {
        this.aiComparisonDialog.loading = false
      }
    },
    handleCancelCreateJobCriterion () {
      this.createJobCriterionConfirmDialog.show = false
    },
    handleJobCriterionTabMessage (event) {
      if (event.origin !== window.location.origin) {
        return
      }
      const data = event.data
      if (data?.hasClosed) {
        this.handleCreateApplicationAIComparison()
      }
    },
    async handleConfirmCreateJobCriterion () {
      this.createJobCriterionConfirmDialog.loading = true
      try {
        const resp = await this.createJobCriterionByParseJob({ job_id: this.jobId })
        if (resp) {
          window.open(addQueryInPath(`/v-admin/job/edit/${this.jobId}`, {
            step: JOB_EDITOR_STEP_TYPE.BASE_INFO,
            standalone_step: JOB_EDITOR_STEP_TYPE.AI_COMPARISON_CRITERION,
            close_tab: 1
          }))
          // 在页面A中的脚本
          if (window.addEventListener) {
            window.addEventListener('message', this.handleJobCriterionTabMessage, false)
          } else {
            window.attachEvent('onmessage', this.handleJobCriterionTabMessage)
          }
        }
      } finally {
        this.createJobCriterionConfirmDialog.loading = false
        this.createJobCriterionConfirmDialog.show = false
      }
    },
    handleInvitePersonalityOperation (rowData) {
      const candidateIds = [rowData.candidate.id]
      const typeId = ASSESSMENT_INVITE_TYPE.PERSONALITY
      this.sendInviteAssessment(typeId, candidateIds)
    },
    handleInviteProblemSolveOperation (rowData) {
      const candidateIds = [rowData.candidate.id]
      const typeId = ASSESSMENT_INVITE_TYPE.PROBLEM_SOLVING
      this.sendInviteAssessment(typeId, candidateIds)
    },

    async handleExportOriginalResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const isSelectAllApplication = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
      const candidateApplyJobIds = _.map(this.selectedCandidateList, 'candidate_apply_job_id')
      if (!candidateApplyJobIds.length) {
        this.$message.warning(this.$t('common.label.noData'))
        return
      }
      if (candidateApplyJobIds.length > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME || (isSelectAllApplication && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.EXPORT_ORIGINAL_RESUME }))
        return
      }

      if (candidateApplyJobIds.length === 1) {
        // 单个导出: 直接下载
        await this.downloadSingleOriginalResume(this.selectedCandidateList[0])
      } else {
        // 批量导出: 调用后端 API，打包发邮件
        await this.exportBatchOriginalResume(candidateApplyJobIds)
      }
    },
    async handleExportOriginalResumeOperation (rowData) {
      await this.downloadSingleOriginalResume(rowData)
    },
    async downloadSingleOriginalResume (rowData) {
      if (!rowData.candidate.resume_path) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.noOriginalResume`))
        return
      }
      try {
        this.$eventBus.$emit('showLoading', true)
        if (!rowData || rowData.is_agency_uploaded_and_hid || !rowData.job || !rowData.candidate || !rowData.job.id || !rowData.candidate.id) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        const companyName = getI18nPropertyValue(rowData.job.company, 'cn_name', 'name')
        const jobName = getI18nPropertyValue(rowData.job, 'cn_title', 'title')
        const fileName = `${companyName}_${jobName}_${rowData.candidate.name}_${rowData.candidate.id}_${moment().format('YYYYMMDD')}`
        const ext = getFileExtension(rowData.candidate.resume_path)
        const downloadFileName = ext ? `${fileName}.${ext}` : fileName
        const result = await applicationApi.getResumeDownloadUrl(rowData.job.id, rowData.candidate.id, { file_name: downloadFileName })
        if (!result || !result.url) {
          this.$message.error(this.$t('common.message.downloadFailed'))
          return
        }

        window.location.href = result.url
      } catch (error) {
        this.$message.error(this.$t('common.message.downloadFailed'))
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async exportBatchOriginalResume (candidateApplyJobIds) {
      try {
        const selectAllCandidate = this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate)
        const resp = await this.exportOriginalResume({
          select_all_application: selectAllCandidate,
          select_all_candidate: selectAllCandidate,
          search_params: this.searchParams,
          application_ids: candidateApplyJobIds,
          job_id: this.jobId
        })

        if (resp && resp.task_id) {
          this.$message.success(this.$t(`${this.i18nPrefix}.message.exportOriginalResumeTaskCreated`))
        }
      } catch (error) {
        this.$message.error(this.$t('common.message.exportFailed'))
      }
    },
    handleAddCommentOperation (rowData) {
      this.commentDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateId: rowData.candidate.id
      }
      this.$refs.addCommentDialog.openDialog()
    },
    handleLastedWorkChange () {
      const params = this.parseSearchToParams(this.search)
      if (params.work_company_name || params.last_work_company_name) {
        this.handelSearch()
      }
    },
    async sendInviteAssessment (typeId, candidateIds, isSelectAll) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.sendInviteNotification({
          type_id: typeId,
          job_id: this.jobId,
          candidate_ids: candidateIds,
          is_all_application: isSelectAll,
          params: this.searchParams
        })
        if (resp) {
          if (candidateIds.length > 1 || isSelectAll) { // 多选或全选
            const candidateCount = isSelectAll ? this.candidateTotalCount : candidateIds.length
            const successCount = resp.success?.length
            const noEmailCount = resp.no_email_count?.length
            const completedCount = resp.ignore?.length
            this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.batchInvite`, {
              candidateCount,
              successCount,
              noEmailCount,
              completedCount
            }))
          } else if (resp.success && resp.success.length > 0) {
            this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.success`))
          } else if (resp.no_email_count && resp.no_email_count.length > 0) {
            this.$message.warning(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.noEmailAccount`))
          } else if (resp.ignore && resp.ignore.length > 0) {
            this.$message.warning(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.hasFinished`))
          } else {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.inviteFinishAssessment.fail`))
          }
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    handleAddTagDialog () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      this.addTagDialog = {
        isSelectAll: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidateList: candidates
      }
      if (candidates.length > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG || (this.isSelectedAllCandidate && this.candidateTotalCount > SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG)) {
        this.$message.warning(this.$t(`${this.i18nPrefix}.message.selectAllCandidateLimit`, { maxLimit: SELECT_ALL_CANDIDATE_LIMIT.ADD_TAG }))
        return
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleAddTagOperation (rowData) {
      this.addTagDialog = {
        isSelectAll: false,
        candidateList: [rowData.candidate.id]
      }
      this.$refs.addTagDialog.showDialog()
    },
    handleChangeStatusOperation (rowData, status) {
      this.changeCandidateStatusDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }

      if (status) {
        this.changeCandidateStatusDialog.defaultStatusKey = status
      } else {
        this.changeCandidateStatusDialog.defaultStatusKey = rowData.status.key
      }
      this.$refs.changeCandidateStatusDialog.showDialog()
    },
    handleCopyCandidateOperation (rowData) {
      this.copyCandidateDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.copyCandidateDialog.showDialog()
    },
    handleContactOperation (rowData) {
      this.contactDialog = {
        isSelectAll: false,
        candidateIds: [rowData.candidate.id]
      }
      this.$refs.contactDialog.openDialog()
    },
    handleInviteHMRatingOperation (rowData) {
      this.ratingDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteHmRatingDialog.showDialog()
    },
    handleInviteInterviewOperation (rowData) {
      this.interviewDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteInterviewDialog.showDialog()
    },
    handleInviteQuestionOperation (rowData) {
      this.questionDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteQuestionDialog.openDialog()
    },
    handleInviteOnboardingOperation (rowData) {
      this.onboardingDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteOnboardingDialog.openDialog()
    },
    handleInviteSatisfactionOperation (rowData) {
      this.satisfactionDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.inviteSatisfactionDialog.openDialog()
    },
    handleInvitePortalOperation (rowData) {
      this.portalDialog = {
        isSelectAll: false,
        applicationList: [rowData]
      }
      this.$refs.invitePortalDialog.openDialog()
    },
    openAddGroupDialogOperation (rowData) {
      this.addCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.addGroupDialog.openDialog()
    },
    async handleInviteAnswerORQuestionOperation (rowData) {
      const params = {
        candidate_ids: [rowData.candidate.id],
        job_id: this.jobId
      }
      const resp = await this.sendInviteAnswerOriginCompanyQuestion(params)
      if (resp) {
        const successCount = resp.send_success_count
        this.$message.success(this.$t(`${this.i18nPrefix}.message.inviteORQuestion`, { inviteCount: 1, successCount: successCount }))
      }
    },
    async handleSaveOperatorCandidateToGroup (groupInfo, callback) {
      const currentGroup = groupInfo.currentGroup
      const talentPoolGroup = groupInfo.talentPoolGroup
      let resp = null
      try {
        resp = await this.saveCandidateGroup({
          candidate_ids: this.addCandidateGroupDialog.candidateList,
          job_id: this.jobId,
          group_list: currentGroup && [currentGroup],
          talent_pool_group: talentPoolGroup,
          remove_bound_group: false,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.message.saveFail'))
        }
      } finally {
        this.loadGroupList()
        callback(resp)
      }
    },
    openMoveGroupDialogOperation (rowData) {
      this.moveCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.moveGroupDialog.openDialog()
    },
    async handleSaveOperatorMovedGroup (groupInfo, callback) {
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: this.moveCandidateGroupDialog.candidateList,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },
    openRemoveGroupDialogOperation (rowData) {
      this.removeCandidateGroupDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadGroupList()
      this.$refs.removedGroupDialog.openDialog()
    },
    async handleSaveOperatorRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: this.removeCandidateGroupDialog.candidateList,
          group_id: groupId,
          comment: comment,
          select_all_candidate: false,
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
      }
    },

    handleExportCandidateAllInfoOperation (rowData) {
      this.exportCandidateAllInfoDialog = {
        isSelectAll: false,
        isOperator: true,
        candidateList: [rowData.candidate.id]
      }
      this.loadExportJobApplicationExcelFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    async handleSaveOperatorExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: false,
        candidate_ids: this.exportCandidateAllInfoDialog.candidateList,
        search_params: this.searchParams,
        job_id: this.jobId,
        export_from_job_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportJobApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    handleExportResumeOperation (rowData) {
      const candidateName = rowData.candidate.name
      const candidateId = rowData.candidate.id
      const date = moment().format('YYYY-MM-DD')
      const companyName = getI18nPropertyValue(rowData.job.company, 'cn_name', 'name')
      const jobName = getI18nPropertyValue(rowData.job, 'cn_title', 'title')
      const downloadFileName = `${companyName}_${jobName}_${candidateName}_${candidateId}_${date}.pdf`
      this.exportSignalPDF(rowData.candidate.id, true, '0', downloadFileName)
    },
    handleExportReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, false, '1')
    },
    handleExportResumeAndReportOperation (rowData) {
      this.exportSignalPDF(rowData.candidate.id, true, '1')
    },
    async exportSignalPDF (candidateId, showBaseInfo, profileType, downloadFileName) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePdf({
        candidate_ids: [candidateId],
        show_base_info: showBaseInfo,
        profile_type: profileType,
        select_all_candidate: false,
        search_params: this.searchParams,
        job_id: this.jobId
      }), (taskId) => this.getExportCandidateProfilePdfTaskStatus({
        task_id: taskId
      }), (taskId) => {
        let downloadUrl = `/django_rest/company/job/application/export/profile/?task_id=${taskId}&download=1`
        if (downloadFileName) {
          downloadUrl += `&file_name=${window.encodeURIComponent(downloadFileName)}`
        }
        window.location.href = this.$DjangoBaseUrl(downloadUrl)
        exportPdfStatus.loading = false
        exportPdfStatus.finished = false
        exportPdfStatus.task = null
      })
    },
    handleExportConsentInfoOperation (rowData) {
      this.exportConsentInfoPDF([rowData])
    },
    async loadSourceChannelList () {
      const params = {
        status: 1,
        global_channel: 1
      }
      const resp = await this.getSourceChannelList(params)
      if (resp) {
        const weChatChannel = createI18nProperty({ id: 0 }, 'i18nName', `${this.i18nPrefix}.label.weChatChannelName`)
        const channelList = _.map(resp.result, item => addI18nProperty(item, 'i18nName', 'cn_name', 'name'))
        channelList.splice(0, 0, weChatChannel)
        this.sourceChannelList = channelList
      }
      return this.sourceChannelList
    },
    async loadCandidateStatusList () {
      const resp = await this.getCandidateStatusList({ is_all: 1 })
      if (resp) {
        this.candidateStatusList = _.map(resp, item => addI18nProperty(item, 'i18nName', 'name_cn', 'name_en'))
      }
      return this.candidateStatusList
    },
    async filterLocationMethod (queryValue, filter) {
      let filteredList = []
      _.chain(queryValue).reverse().filter().forEach((query, index) => {
        if (_.isEmpty(filteredList)) {
          filteredList = _.filter(this.location.data, location => {
            return _.includes(location.cn_name, query)
          })
        } else {
          const tempList = _.filter(filteredList, location => {
            let parent = location.parent
            if (index === 2) {
              parent = parent?.parent
            }
            if (parent) {
              return _.chain(parent.searchTextList)
                .map(item => _.toUpper(item))
                .some(item => _.includes(item, _.toUpper(query)))
            }
            return true
          })
          if (!_.isEmpty(tempList)) {
            filteredList = tempList
          }
        }
      }).value()
      return filteredList
    },
    async getLocationList () {
      if (this.location.hasLoad) {
        return
      }
      if (this.expectedLocation.hasLoad) {
        this.location = this.expectedLocation
      } else {
        this.location.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.location.data = _.map(resp, location => {
          addI18nProperty(location, 'i18nName', 'cn_name', 'name')
          location.searchTextList = []
          location.searchTextList.push(location.name, location.cn_name, location.pinyin_name)
          if (location.parent_id) {
            const locationInfo = _.find(resp, item => item.id === location.parent_id)
            location.parent = locationInfo
            location.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }
          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === location.id)) {
            location.searchTextList = null
          }
          if (location.type_code === 'region') {
            location.searchTextList = null
          }
          const nameList = []
          if (location.parent) {
            this.getParentLocation(location, nameList)
          }
          const searchLabelList = [location.cn_name]
          if (location.parent) {
            this.getParentLocationCnName(location, searchLabelList)
          }
          location.searchLabelList = _.reverse(searchLabelList)
          location.locationName = _.chain([location.i18nName, ...nameList]).filter().join(' - ').value()
          return location
        })
      }
      return this.location.data
    },
    async loadLocationList (keywords, loadData, valueList) {
      this.location.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.location.data, location => {
        if (valueList?.length > 0) {
          return _.includes(valueList, location.id)
        } else {
          const keywordsList = _.map(location.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.location.page = 1
      this.location.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.location.pageSize)
    },
    getParentLocation (location, nameList) {
      const parent = location.parent
      if (parent) {
        if (parent.searchTextList) {
          nameList.push(parent.i18nName)
        }
        if (parent.parent_id) {
          this.getParentLocation(parent, nameList)
        }
      }
    },
    getParentLocationCnName (location, nameList) {
      const parent = location.parent
      if (parent) {
        nameList.push(parent.cn_name)
        if (parent.parent_id) {
          this.getParentLocationCnName(parent, nameList)
        }
      }
    },
    async loadLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.location = locationList
      }
    },
    async initSchoolList () {
      if (this.school.hasLoad) {
        return
      }
      this.school.hasLoad = true
      const resp = await this.getSchoolList()
      if (!resp) {
        return
      }
      this.school.data = _.map(resp.schools, school => {
        addI18nProperty(school, 'i18nName', 'cn_name', 'name')
        school.searchTextList = []
        school.searchTextList.push(school.name, school.cn_name, school.pinyin_name)
        return school
      })
      return this.school.data
    },
    async initTagList (tag, category, type, key) {
      if (tag.hasLoad) {
        return
      }
      tag.hasLoad = true
      if (key) {
        await this.loadTagList(category, type, key, true)
        tag.data = this.tagMap[type][key]
      } else {
        await this.loadTagList(category, type)
        tag.data = this.tagMap[type]
      }
      return tag.data
    },
    resetSkillTag (filter) {
      this.skillTag.keywords = null
      this.skillTag.currentData = []
      this.skillTag.page = 1
      if (filter?.option) {
        filter.option.data = []
      }
      return []
    },
    async initSkillTagList () {
      if (!this.skillTag.hasLoad) {
        const skillTagKey = [RESUME_SDK_TAG_KEYS.JOB_SKILL, RESUME_SDK_TAG_KEYS.SOFT_SKILL].join(',')
        this.skillTag.hasLoad = true
        await this.loadTagList('system', RESUME_SDK_TAG_TYPES.SKILLS, skillTagKey, true)
        this.skillTag.data = this.tagMap[RESUME_SDK_TAG_TYPES.SKILLS]?.[skillTagKey] || []
      }
      return this.skillTag.data
    },
    getSkillTagNoDataText () {
      if (!_.trim(this.skillTag.keywords)) {
        return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
      }
      return this.$t('el.select.noMatch')
    },
    getSkillTagSelectAllOptions (filter) {
      if (!_.trim(this.skillTag.keywords) || !filter?.option?.data?.length) {
        return []
      }
      return this.skillTag.currentData || []
    },
    async loadSkillTagList (keywords, valueList) {
      this.skillTag.keywords = keywords
      if (valueList?.length > 0) {
        return this.loadSkillTagSelectedList(valueList)
      }
      if (!_.trim(keywords)) {
        this.skillTag.currentData = []
        this.skillTag.page = 1
        return []
      }
      await this.initSkillTagList()
      return this.searchItemList(this.skillTag, keywords, null, valueList)
    },
    async loadSkillTagSelectedList (valueList) {
      await this.initSkillTagList()
      if (!valueList?.length) {
        return []
      }
      const selectedList = _.filter(this.skillTag.data || [], tag => _.includes(valueList, tag.id))
      this.skillTag.currentData = selectedList
      return selectedList
    },
    async loadSkillTagTemplate (valueList, filter, formattedFilterValues) {
      const selectedList = await this.loadSkillTagSelectedList(valueList)
      filter.option.data = selectedList
      formattedFilterValues.skillTag = selectedList
    },
    async filterSkillTagMethod (value, filter) {
      const selectedList = await this.loadSkillTagSelectedList([value])
      const optionList = _.uniqBy([...(filter.option.data || []), ...selectedList], 'id')
      filter.option.data = optionList
      return optionList
    },
    async initCRMTagList (crmTag) {
      if (!this.hasCRMTagPermission || crmTag.hasLoad) {
        return
      }
      crmTag.hasLoad = true
      const params = {
        is_company_tag: 1,
        need_disabled: 1,
        tag_category: ['manual', 'smart'].join(',')
      }
      const resp = await this.searchTag(params)
      if (resp) {
        const tagList = _.map(resp, tag => {
          const tagInfo = tag
          tagInfo.searchTextList = [tag.name, tag.cn_name]
          addI18nProperty(tagInfo, 'i18nName', 'cn_name', 'name')
          return tagInfo
        })
        crmTag.data = this.orderItemList(tagList)
      }
      return crmTag.data
    },
    orderItemList (tagList) {
      if (isEn()) {
        return _.orderBy(tagList, ['name'], ['asc'])
      } else {
        return tagList.sort((a, b) => {
          return a.cn_name.localeCompare(b.cn_name)
        })
      }
    },
    initSelectData (itemList, page) {
      if (!itemList.data) {
        return []
      }
      itemList.page = page
      itemList.currentData = this.orderItemList(itemList.data)
      return itemList.currentData.slice(0, page * itemList.pageSize)
    },
    async searchItemList (item, keywords, loadData, valueList) {
      item.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return this.initSelectData(item, 2)
      }
      const itemList = this.orderItemList(item.data)
      const filteredList = _.filter(itemList, item => {
        if (valueList?.length > 0) {
          return _.includes(valueList, item.id)
        } else {
          const keywordsList = _.map(item.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      item.page = 1
      item.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, item.pageSize)
    },
    loadMoreData (item, filter) {
      if (item.currentData && item.page * item.pageSize > item.currentData.length) {
        return
      }
      const data = item.currentData.slice(item.page * item.pageSize, (item.page + 1) * item.pageSize)
      item.page += 1
      filter.option.data.push(...data)
    },
    async initMajorList () {
      if (this.major.hasLoad) {
        return
      }
      this.major.hasLoad = true
      const resp = await this.getMajorList()
      if (!resp) {
        return
      }
      this.major.data = _.map(resp.majors, major => {
        addI18nProperty(major, 'i18nName', 'cn_name', 'name')
        major.searchTextList = []
        major.searchTextList.push(major.name, major.cn_name)
        return major
      })
      return this.major.data
    },
    async loadLanguageList () {
      const resp = await this.getLanguageList()
      if (resp) {
        this.languageList = _.map(resp.languages, item => addI18nProperty(item, 'i18nName', 'cn_name', 'en_name'))
      }
      return this.languageList
    },
    async loadSchoolList (keywords, loadData, valueList) {
      this.school.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.school.data, school => {
        if (valueList?.length > 0) {
          return _.includes(valueList, school.id)
        } else {
          const keywordsList = _.map(school.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.school.page = 1
      this.school.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.school.pageSize)
    },
    async loadCompanyPolicyList () {
      const vm = this
      const resp = await this.getCompanyPolicyItemList()
      if (resp) {
        const sortedPolicy = _.orderBy(_.values(resp), ['created_time'], ['desc'])
        const policyList = []
        _.forEach(sortedPolicy, policy => {
          _.forEach(policy.policy_list, policyItem => {
            Object.defineProperty(policyItem, 'i18nName', {
              enumerable: true,
              configurable: true,
              get () {
                const createdTime = moment(policy.created_time).format('YYYY/MM/DD')
                const code = vm.$t(`${vm.i18nPrefix}.label.consentVersionCode`)
                const i18nContent = getI18nPropertyValue(this, 'content_cn', 'content_en')
                const i18nName = `${createdTime} ${code}: ${i18nContent}`
                return i18nName
              }
            })
            const optionList = _.map(CONSENT_STATUS, (val, key) => {
              const option = { value: `${policyItem.id}-${val}` }
              Object.defineProperty(option, 'i18nName', {
                enumerable: true,
                configurable: true,
                get () {
                  return vm.$t(`${vm.i18nPrefix}.consentStatus.${key}`)
                }
              })
              return option
            })
            policyItem.status_list = optionList
            policyList.push(policyItem)
          })
        })
        this.companyPolicyList = policyList
        return this.companyPolicyList
      }
    },
    async loadTagList (tagCategory, tagType, tagKey, needResumeSDKTag) {
      if (!this.hasCRMTagPermission && !this.hasMicrositeCampaignPermission && !this.hasParseResumeTagPermission) {
        return
      }
      const params = {
        tag_category: tagCategory,
        tag_type: tagType
      }
      if (tagKey) {
        params.tag_key = tagKey
      }
      if (this.hasParseResumeTagPermission && needResumeSDKTag) {
        params.is_common_tag = 1
      } else {
        params.is_company_tag = 1
      }
      const resp = await this.searchTag(params)
      _.forEach(resp, tag => {
        addI18nProperty(tag, 'i18nName', 'cn_name', 'name')
        tag.searchTextList = [tag.name, tag.cn_name]
      })
      if (resp) {
        const tagList = this.orderItemList(resp)
        _.set(this.tagMap, `${tagType}${tagKey ? `.${tagKey}` : ''}`, tagList)
      }
    },
    async loadSalaryList () {
      const resp = await this.getSalaryList()
      if (resp) {
        this.salaryList = resp.salary_list
      }
    },
    async loadIndustryList () {
      const resp = await this.getIndustryList()
      if (resp) {
        const industryList = _.map(resp.industry_list, industry => {
          industry.searchTextList = [industry.cn_name, industry.name]
          addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
          return industry
        })
        this.industryList = this.orderItemList(industryList)
      }
    },
    formatConsentFilterDisplayValue (value, filter, filterName, group, groupKey) {
      const displayValueList = []
      _.forEach(value, option => {
        const displayValue = {
          valueKey: null,
          value: option.value,
          summary: null,
          detail: null
        }
        const optionValue = option.value + ''
        const policyItemId = parseInt(optionValue.split('-')[0])
        const policyItem = _.find(this.companyPolicyList, policy => policy.id === policyItemId)
        displayValue.summary = option.i18nName
        displayValue.detail = `${group.title}-${policyItem.i18nName}`
        displayValueList.push(displayValue)
      })
      return displayValueList
    },
    async loadGroupList (needUnGrouped) {
      const params = {
        job_id: this.jobId,
        need_talent_pool_group: 1
      }
      if (needUnGrouped) {
        params.need_ungrouped = true
      }
      const resp = await this.getGroupList(params)
      if (resp) {
        const groupList = resp.group_list
        if (needUnGrouped) {
          groupList.splice(0, 0, {
            id: -1,
            text: this.$t(`${this.i18nPrefix}.label.ungrouped`),
            count: resp.ungrouped_candidate_count
          })
        }
        this.groupList = groupList
        this.talentGroupList = resp.talent_pool_group_list
      }
      return this.groupList
    },
    async loadRecruiterQuestionnaire () {
      const resp = await this.getRecruiterQuestionnaire({ jobId: this.jobId })
      if (resp) {
        this.recruiterQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
      }
      return this.recruiterQuestionnaire
    },
    async loadApplicationQuestionnaire () {
      const resp = await this.getApplicationQuestionnaire({ jobId: this.jobId })
      if (resp) {
        this.applicationQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
      }
      return this.applicationQuestionnaire
    },
    async loadPrescreenQuestionnaire () {
      const resp = await this.getPrescreenQuestionnaire({ jobId: this.jobId })
      if (resp) {
        this.prescreenQuestionnaire = _.filter(resp, item => HAS_OPTIONS_QUESTION_TYPES.includes(item.type))
      }
      return this.prescreenQuestionnaire
    },
    async loadCandidateSurveyQuestionList () {
      const resp = await this.getCompanySurveyQuestionList({ survey_type: 'candidate' })
      if (resp) {
        this.candidateSurveyQuestionList = _.map(resp, question => {
          addI18nProperty(question, 'i18nName', 'cn_name', 'name')
          question.answer = _.map(question.answer, answer => {
            addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
            answer.questionId = question.id
            return answer
          })
          return question
        })
        return this.candidateSurveyQuestionList
      }
    },
    async loadEmployeeSurveyQuestionList () {
      const resp = await this.getCompanySurveyQuestionList({ survey_type: 'employee' })
      if (resp) {
        this.employeeSurveyQuestionList = _.map(resp, question => {
          addI18nProperty(question, 'i18nName', 'cn_name', 'name')
          question.answer = _.map(question.answer, answer => {
            addI18nProperty(answer, 'i18nName', 'cn_name', 'name')
            answer.questionId = question.id
            return answer
          })
          return question
        })
        return this.employeeSurveyQuestionList
      }
    },
    async loadCvOwnerList () {
      const resp = await this.getCvOwnerList()
      const hrList = _.orderBy(resp.hr_list, hr => hr.name.toLowerCase(), 'asc')
      const agencyList = _.orderBy(resp.agency_list, agency => agency.name.toLowerCase(), 'asc')
      const disabledHrList = _.filter(hrList, hr => hr.is_disabled)
      const disabledAgencyList = _.filter(agencyList, agency => agency.is_disabled)
      const cvOwnerList = [
        createI18nProperty({
          children: _.filter(hrList, hr => !hr.is_disabled)
        }, 'label', `${this.i18nPrefix}.cvOwner.hr`),
        createI18nProperty({
          children: _.filter(agencyList, agency => !agency.is_disabled)
        }, 'label', `${this.i18nPrefix}.cvOwner.agency`)
      ]
      if (disabledHrList.length > 0) {
        cvOwnerList.push(createI18nProperty({ children: disabledHrList }, 'label', `${this.i18nPrefix}.cvOwner.disabledHr`))
      }
      if (disabledAgencyList.length > 0) {
        cvOwnerList.push(createI18nProperty({ children: disabledAgencyList }, 'label', `${this.i18nPrefix}.cvOwner.disabledAgency`))
      }
      this.cvOwnerList = cvOwnerList
      return this.cvOwnerList
    },
    async handleSaveEditGroup (groupInfo, callback) {
      const groupId = groupInfo.id
      let resp = null
      if (!groupId || groupId === -1) {
        return
      }
      try {
        const params = {
          group_id: groupId,
          text: groupInfo.text
        }
        resp = await this.updateGroup(params)
      } finally {
        this.loadGroupList()
        callback(resp)
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            _.forEach(filters, group => {
              if (group.id === groupId) {
                group.text = groupInfo.text
              }
            })
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = filters
          }
        }
      }
    },
    async handleDeleteGroup (groupInfo) {
      const groupId = groupInfo.id
      if (!groupId || groupId === -1) {
        return
      }
      const params = {
        group_id: groupId
      }
      const resp = await this.deleteGroup(params)
      if (resp) {
        this.loadGroupList()
        this.$message({
          message: this.$t(`${this.i18nPrefix}.message.deleteGroupSuccess`),
          type: 'success'
        })
        const search = this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL]
        let filters = []
        if (search && search.group) {
          filters = search.group
          if (filters.length > 0) {
            this.search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = _.filter(filters, group => group.id !== groupId)
          }
        }
      }
    },
    async handleSaveMovedGroup (groupInfo, callback) {
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.moveCandidateGroup({
          candidate_ids: candidates,
          from_group_id: groupInfo.from,
          to_group: groupInfo.to,
          comment: groupInfo.comment,
          remove_bound_group: false,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
        this.handleStatusChangedSuccess()
      }
    },
    async handleSaveRemovedGroup (groupInfo, callback) {
      const groupId = groupInfo.from
      const comment = groupInfo.comment
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      let resp = null
      try {
        resp = await this.removeCandidateFromGroup({
          candidate_list: candidates,
          group_id: groupId,
          comment: comment,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        this.loadGroupList()
      } finally {
        callback(resp)
        this.handleStatusChangedSuccess()
      }
    },
    handleSearchCandidateByGroup (groupInfo) {
      const search = this.$refs.filterList.search
      search[FILTER_GROUP_TYPE.APPLICATION_DETAIL].group = _.map(groupInfo, item => item.id)
      this.$refs.filterList.resetSearch({ search })
    },
    async saveAddedGroup (groupInfo, callback) {
      const currentGroup = groupInfo.currentGroup
      const talentPoolGroup = groupInfo.talentPoolGroup
      let resp = null
      const candidates = []
      _.forEach(this.selectedCandidateList, application => {
        candidates.push(application.candidate.id)
      })
      try {
        resp = await this.saveCandidateGroup({
          candidate_ids: candidates,
          job_id: this.jobId,
          group_list: currentGroup && [currentGroup],
          talent_pool_group: talentPoolGroup,
          remove_bound_group: false,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams
        })
        if (resp) {
          this.$message.success(this.$t('common.message.saveSuccess'))
        } else {
          this.$message.success(this.$t('common.message.saveFail'))
        }
      } finally {
        this.loadGroupList()
        callback(resp)
        this.handleStatusChangedSuccess()
      }
    },
    handleExportCandidateAllInfo () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportCandidateAllInfoDialog = {
        isSelectAll: this.isSelectedAllCandidate,
        candidateList: _.map(this.selectedCandidateList, item => item.candidate.id)
      }
      this.loadExportJobApplicationExcelFields()
      this.$refs.exportCandidateAllInfoDialog.showDialog()
    },
    handleExportResume () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '0')
    },
    handleExportReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(false, '1')
    },
    handleExportResumeAndReport () {
      const hasSelected = this.hasSelected()
      if (!hasSelected) {
        return
      }
      this.exportPDF(true, '1')
    },
    handleExportConsentInfo () {
      this.exportConsentInfoPDF()
    },
    async exportPDF (showBaseInfo, profileType) {
      const exportPdfStatus = this.exportPdfStatus
      if (exportPdfStatus.loading) {
        return
      }
      exportPdfStatus.loading = true
      exportPdfStatus.finished = false
      const exportCandidates = []
      _.forEach(this.selectedCandidateList, candidate => {
        exportCandidates.push(candidate.candidate.id)
      })
      if (exportCandidates.length === 1) {
        exportPdfStatus.task = new AsyncTask(() => this.exportCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams,
          job_id: this.jobId
        }), (taskId) => this.getExportCandidateProfilePdfTaskStatus({
          task_id: taskId
        }), (taskId) => {
          window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/profile/?task_id=${taskId}&download=1`)
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        })
      } else {
        const resp = await this.exportCandidateProfilePdf({
          candidate_ids: exportCandidates,
          show_base_info: showBaseInfo,
          profile_type: profileType,
          select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
          search_params: this.searchParams,
          job_id: this.jobId
        })
        if (resp) {
          this.$message.success({
            dangerouslyUseHTMLString: true,
            message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
            showClose: true,
            duration: 10 * 1000 // 10s
          })
          exportPdfStatus.loading = false
          exportPdfStatus.finished = false
          exportPdfStatus.task = null
        }
      }
    },
    async exportConsentInfoPDF (candidateList = this.selectedCandidateList) {
      const exportConsentStatus = this.exportConsentStatus
      if (exportConsentStatus.loading) {
        return
      }
      exportConsentStatus.loading = true
      exportConsentStatus.finished = false
      exportConsentStatus.task = new AsyncTask(() => this.exportConsentPDF({
        candidate_ids: _.map(candidateList, item => item.candidate.id),
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        search_params: this.searchParams,
        job_id: this.jobId
      }), (taskId) => this.getExportConsentPDFaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/company/job/application/export/consent/?task_id=${taskId}&download=1`)
        exportConsentStatus.loading = false
        exportConsentStatus.finished = false
        exportConsentStatus.task = null
      })
    },
    async saveExportCandidateAllInfo (optionInfo, callback) {
      const params = {
        field_list: optionInfo,
        select_all_candidate: this.isSelectedAllCandidate || (this.isClickSelectAll && this.selectAllIsIndeterminate),
        candidate_ids: _.map(this.selectedCandidateList, item => item.candidate.id),
        search_params: this.searchParams,
        job_id: this.jobId,
        export_from_job_applicant_list: true
      }
      let resp = null
      try {
        resp = await this.createExportJobApplicationExcelInfoTask(params)
        this.$message.success({
          dangerouslyUseHTMLString: true,
          message: this.$t(`${this.i18nPrefix}.message.ExcelDownloadTip`),
          showClose: true,
          duration: 10 * 1000 // 10s
        })
      } finally {
        callback(resp)
      }
    },
    async loadSearchTemplateList () {
      const resp = await this.getAccountPageConfigList({ page_type: 'JOB_APPLICATION_LIST' })
      if (resp) {
        this.searchTemplateList = _.map(resp, pageConfig => {
          return {
            _config: pageConfig,
            id: pageConfig.id,
            name: pageConfig.config.name,
            search: pageConfig.config.search
          }
        })
      }
    },
    async loadJobInfo () {
      this.jobLoading = true
      try {
        const resp = await this.getJobInfo({ jobId: this.jobId })
        if (resp) {
          const nps = resp.nps
          const job = resp.job
          this.nps.value = parseInt(nps.value || 0)
          this.nps.nValue = nps.n_value || 0
          this.nps.inviteCount = nps.invitation_count || 0
          this.nps.rate = parseInt(nps.rate || 0)
          addI18nProperty(job, 'jobName', 'cn_name', 'name')
          this.jobName = job.jobName
          this.hasProblemSolvingRequired = job.problem_solving_required === '1'
          this.hasAssessmentValueRequired = job.assessment_value_required === '1'
          this.hasPersonalityRequired = job.personality_required === '1'
          this.isElcOriginCompany = resp.is_elc_origin_company
          this.job = job
          this.initCandidateStatusCount(job)
        }
      } finally {
        this.jobLoading = false
      }
    },
    async loadJobAIInterviewRoomInfo () {
      if (!this.hasAIInterviewPermission) {
        return
      }
      if (!this.jobId) {
        this.jobAIInterviewRoomId = null
        return
      }
      try {
        const resp = await this.getJobInterviewRoomInfo(this.jobId)
        this.jobAIInterviewRoomId = resp?.interview_room_id || null
      } catch (e) {
        this.jobAIInterviewRoomId = null
      }
    },
    async loadStatusGroupList () {
      if (this.statusLoaded) {
        return this.statusList
      }
      const resp = await this.getCandidateStatusGroupList({
        job_id: this.jobId
      })
      if (resp) {
        const statusList = []
        const statusKeyList = []
        _.forEach(resp.status_list, status => {
          statusList.push(addI18nProperty(status, 'i18nName', 'name_cn', 'name_en'))
          statusKeyList.push(status.key)
        })
        this.statusGroupList = _.map(resp.group_list, group => {
          createI18nProperty(group, 'i18nName', `${this.i18nPrefix}.STATUS_GROUP.${group.name}`)
          _.forEach(group.status_list, status => {
            addI18nProperty(status, 'i18nName', 'name_cn', 'name_en')
            status.canChangeTo = statusKeyList.includes(status.key)
          })
          return group
        })
        this.statusList = statusList
        this.statusLoaded = true

        return this.statusList
      }
    },
    async getExpectedLocationList () {
      if (this.expectedLocation.hasLoad) {
        return
      }
      if (this.location.hasLoad) {
        this.expectedLocation = this.location
      } else {
        this.expectedLocation.hasLoad = true
        const resp = await this.getWorldLocationList()
        if (!resp) {
          return
        }
        this.expectedLocation.data = _.map(resp, expectedLocation => {
          addI18nProperty(expectedLocation, 'i18nName', 'cn_name', 'name')
          expectedLocation.searchTextList = []
          expectedLocation.searchTextList.push(expectedLocation.name, expectedLocation.cn_name, expectedLocation.pinyin_name)
          if (expectedLocation.parent_id) {
            const locationInfo = _.find(resp, item => item.id === expectedLocation.parent_id)
            expectedLocation.parent = locationInfo
            expectedLocation.searchTextList.push(locationInfo.name, locationInfo.cn_name, locationInfo.pinyin_name)
          }

          // 处理四个直辖市, 不出现在下拉列表中
          if (_.findKey(MUNICIPALITY_CITY, city => city === expectedLocation.id)) {
            expectedLocation.searchTextList = null
          }
          if (expectedLocation.type_code === 'region') {
            expectedLocation.searchTextList = null
          }
          const nameList = []
          if (expectedLocation.parent) {
            this.getParentLocation(expectedLocation, nameList)
          }
          expectedLocation.locationName = _.chain([expectedLocation.i18nName, ...nameList]).filter().join(' - ').value()
          return expectedLocation
        })
      }
      return this.expectedLocation.data
    },
    async loadExpectedLocationList (keywords, loadData, valueList) {
      this.expectedLocation.keywords = keywords
      if (!_.trim(keywords) && !valueList?.length > 0) {
        return []
      }
      const filteredList = _.filter(this.expectedLocation.data, expectedLocation => {
        if (valueList?.length > 0) {
          return _.includes(valueList, expectedLocation.id)
        } else {
          const keywordsList = _.map(expectedLocation.searchTextList, item => _.toUpper(item))
          return _.some(keywordsList, item => _.includes(item, _.toUpper(keywords)))
        }
      })
      this.expectedLocation.page = 1
      this.expectedLocation.currentData = filteredList
      return valueList ? filteredList : filteredList.slice(0, this.expectedLocation.pageSize)
    },
    async loadMetaIndustryList () {
      if (!this.metaIndustryListLoader) {
        this.metaIndustryListLoader = this.getMetaIndustryList().then(resp => {
          if (resp) {
            const industryList = []
            const childrenMap = {}
            _.forEach(resp, (industry) => {
              industry.searchTextList = [industry.cn_name, industry.name]
              addI18nProperty(industry, 'i18nName', 'cn_name', 'name')
              if (industry.parent_id) {
                const children = childrenMap[industry.parent_id]
                if (children) {
                  children.push(industry)
                } else {
                  childrenMap[industry.parent_id] = [industry]
                }
              } else {
                if (!childrenMap[industry.id]) {
                  childrenMap[industry.id] = []
                }
                industry.children = childrenMap[industry.id]
                industryList.push(industry)
              }
              this.metaIndustryList = this.orderTagList(industryList)
            })
          }
        })
      }
      await this.metaIndustryListLoader
      return this.metaIndustryList
    },
    async loadMetaJobFunctionList () {
      if (!this.metaJobFunctionListLoader) {
        this.metaJobFunctionListLoader = this.getMetaJobFunctionList().then(resp => {
          if (resp) {
            const jobFunctionList = _.map(resp, jobFunction => {
              jobFunction.searchTextList = [jobFunction.cn_name, jobFunction.name]
              return addI18nProperty(jobFunction, 'i18nName', 'cn_name', 'name')
            })
            this.metaJobFunctionList = this.orderTagList(jobFunctionList)
          }
        })
      }
      await this.metaJobFunctionListLoader
      return this.metaJobFunctionList
    },
    orderTagList (tagList) {
      if (isEn()) {
        return _.orderBy(tagList, ['name'], ['asc'])
      } else {
        return tagList.sort((a, b) => {
          return a.cn_name.localeCompare(b.cn_name)
        })
      }
    },
    async loadExpectedLocationTemplate (valueList, filter, formattedFilterValues) {
      if (valueList?.length < 1) {
        return []
      }
      const locationList = await this.loadExpectedLocationList(null, null, valueList)
      if (locationList.length > 0) {
        filter.option.data = locationList
        formattedFilterValues.expectedLocation = locationList
      }
    },
    async loadExportJobApplicationExcelFields () {
      if (this.loading) {
        return
      }
      this.loading = true
      const resp = await this.getExportJobApplicationExcelFieldInfo()
      if (resp) {
        const parentGroupField = _.groupBy(resp, 'parent_field')
        const fieldList = []
        _.forEach(PARENT_FIELD_NAME_LIST, (value, key) => {
          const childrenFields = parentGroupField[key]
          _.forEach(childrenFields, field => {
            addI18nProperty(field, 'i18nName', 'cn_name', 'en_name')
          })
          let fieldNote = null
          if (childrenFields.length === 1) {
            const childrenField = childrenFields[0]
            fieldNote = {
              i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
              id: key,
              children: [],
              col_index: childrenField.col_index,
              data_type: childrenField.data_type,
              header_value: childrenField.i18nName,
              cn_name: childrenField.cn_name,
              en_name: childrenField.en_name
            }
          } else {
            fieldNote = {
              i18nName: this.$t(`${this.i18nPrefix}.PARENT_FIELD_NAME_LIST.${value}`),
              id: key,
              children: childrenFields
            }
          }
          if (fieldNote) {
            fieldList.push(fieldNote)
          }
        })
        this.exportInfo.data[0].children = fieldList
      }
      this.loading = false
    },
    async handleCreateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.createAccountPageConfig({
          page_type: 'JOB_APPLICATION_LIST',
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleUpdateSearchTemplate (template, callback) {
      if (this.isSavingSearchTemplate) {
        return
      }
      this.isSavingSearchTemplate = true
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.updateAccountPageConfig({
          id: template._config.id,
          config: {
            name: template.name,
            search: template.search
          }
        })
        if (resp) {
          const templateInfo = {
            _config: resp,
            id: resp.id,
            name: resp.config.name,
            search: resp.config.search
          }
          callback(templateInfo)
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.isSavingSearchTemplate = false
      }
    },
    async handleClearSearchTemplate () {
      this.searchTemplate = null
    },
    async handleDeleteSearchTemplate (searchTemplate, deletedTemplateIndex) {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.deleteAccountPageConfig({
          id: searchTemplate.id
        })
        if (resp) {
          this.searchTemplateList.splice(deletedTemplateIndex, 1)
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.deleteSuccess`)
          })
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    initPageData () {
      this.getLocationList()
      this.loadStatusGroupList()
      this.loadSalaryList()
      this.loadIndustryList()
      this.loadGroupList(true)
      return Promise.all([
        this.loadJobInfo(),
        this.loadJobAIInterviewRoomInfo(),
        this.loadSearchTemplateList(),
        this.loadCompanyPolicyList(),
        this.loadCandidateStatusList(),
        this.getRefreshAIResumeMatchTaskStatus()
      ])
    },
    getNoDataText (info) {
      if (!info.data || info.data.length === 0) {
        return this.$t('el.select.noData')
      } else if (info.keywords && (!info.currentData || info.currentData.length === 0)) {
        return this.$t('el.select.noMatch')
      }
      return this.$t(`${this.i18nPrefix}.label.pleaseStartTyping`)
    },
    parseSearchToParams (search) {
      const params = { order: `${this.listOrder.order === '-' ? '-' : ''}${this.listOrder.prop}` }
      const filterList = this.filterList
      _.forEach(search, (group, groupKey) => {
        if (_.includes(AI_EXTRA_PARAMS, groupKey)) {
          if (_.isArray(group)) {
            group = _.chain(group).filter().join(',').value()
          }
          params[groupKey] = group
          return
        }
        if (groupKey === 'keywords') {
          params.keywords = group
          return
        }
        if (groupKey === 'candidateName') {
          params.candidate_name = group
          return
        }
        if (groupKey === 'candidateId') {
          params.candidate_id = _.filter(group, item => item && !isNaN(item)).join(',')
          return
        }
        const groupFilters = filterList[groupKey]
        if (groupFilters?.hidden) {
          return
        }
        const excludeFilterNames = group._exclude
        _.forEach(group, (filterValue, filterName) => {
          const filter = groupFilters?.filterList[filterName]
          if (!filter || !filterValue) {
            return
          }
          filter.setParam(params, filterValue, _.includes(excludeFilterNames, filterName))
        })
      })
      return params
    },
    async handelSearch (search, nextPage, targetPage) {
      if (nextPage) {
        if (this.pagination.page === this.pagination.totalPage) {
          this.$message.warning(this.$t(`${this.i18nPrefix}.message.noData`))
          return
        }
        this.pagination.page += 1
      } else {
        this.pagination.page = 1
      }
      this.listLoading = true
      if (!search) {
        search = this.search
      } else {
        this.search = search
      }
      const params = this.parseSearchToParams(search)
      this.searchParams = params
      const page = targetPage || this.pagination.page
      const candidateList = []
      const promiseList = _.chain(this.pagination.page).range(page + 1)
        .map((val) => {
          return this.getJobApplicationList({
            jobId: this.jobId,
            params: {
              ...params,
              with_hm_score: this.hasInterviewPermission ? 1 : null,
              page: val,
              page_size: this.pagination.pageSize
            }
          }).catch((resp) => {
            if (resp?.code === 10001010) {
              // 忽略错误: PAGE_NO_RESULT=(10001010, 'That page contains no results'),
              return null
            }
            return Promise.reject(resp)
          })
        }).value()
      const respList = await Promise.all(promiseList)
      let totalPage = this.pagination.totalPage
      let candidateTotalCount = this.candidateTotalCount
      let needShowAiInterview = this.needShowAiInterview
      const candidateIdSelectedMap = {}
      _.forEach(this.selectedCandidateList, item => {
        candidateIdSelectedMap[item.candidate.id] = item.selected
      })
      const loadedPages = []
      _.forEach(respList, resp => {
        if (resp) {
          const vm = this
          loadedPages.push(resp.page)
          totalPage = resp.total_page
          candidateTotalCount = resp.total_count
          needShowAiInterview = resp.need_show_ai_interview
          _.forEach(resp.data, applicant => {
            const oldCandidateIsSelected = _.get(candidateIdSelectedMap, applicant.candidate.id)
            applicant.selected = oldCandidateIsSelected || false
            const candidate = applicant.candidate
            candidate.age = candidate.birthday ? moment().diff(candidate.birthday, 'year') : ''
            candidate.name = applicant.is_agency_uploaded_and_hid ? this.$t(`${this.i18nPrefix}.label.hidedCandidateName`) : candidate.name
            const hasSolvingProblemFit = candidate.problem_solving_finished && candidate.mental_ability
            const hasPersonalityFit = candidate.personality_finished && (candidate.organization_fit || candidate.job_fit)
            const hasAiInterviewFit = applicant.ai_interview_info && applicant.ai_interview_info.is_finished
            const hasAIInterviewScore = applicant.ai_interview_score
            const hasInterviewScore = applicant.hm_interview_total_rate
            candidate.hasFit = (this.hasAssessmentPermission && (hasPersonalityFit || hasSolvingProblemFit)) || (this.canViewAIFitScore && applicant.ai_match_info?.resume_ai_match_score) || hasAiInterviewFit || (this.hasAIInterviewPermission && hasAIInterviewScore) || hasInterviewScore
            Object.defineProperty(candidate, 'maxDegreeI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const maxDegree = candidate.max_degree
                // TODO: 学历不存在的时候怎么处理，待确认
                return getConstantI18nValue(DEGREE, maxDegree, 'meta.DEGREE')
              }
            })
            Object.defineProperty(candidate, 'candidateStatusName', {
              configurable: true,
              enumerable: true,
              get () {
                let i18nKey = null
                if (candidate.is_alumni) {
                  i18nKey = 'alumni'
                } else if (candidate.is_employee) {
                  i18nKey = 'employee'
                } else {
                  i18nKey = 'candidate'
                }
                if (!applicant.reviewed) {
                  i18nKey += 'New'
                }
                return vm.$t(`${vm.i18nPrefix}.label.${i18nKey}`)
              }
            })
            Object.defineProperty(applicant, 'statusName', {
              configurable: true,
              enumerable: true,
              get () {
                return applicant.status.i18nName || getI18nPropertyValue(applicant.status, 'name_cn', 'name_en')
              },
              set (status) {
                applicant.status = status
              }
            })
            Object.defineProperty(applicant, 'locationI18nName', {
              configurable: true,
              enumerable: true,
              get () {
                const location = applicant.candidate.location
                const province = getI18nPropertyValue(location.province, 'cn_name', 'name')
                const city = getI18nPropertyValue(location.city, 'cn_name', 'name')
                return city || province
              }
            })
            Object.defineProperty(applicant, 'totalWorkYear', {
              configurable: true,
              enumerable: true,
              get () {
                const totalWorkYear = applicant.candidate.total_work_year
                if (!totalWorkYear) {
                  return ''
                }
                let totalWorkYearI18nName = ''
                if (totalWorkYear < 1) {
                  totalWorkYearI18nName = `${_.ceil(totalWorkYear * 12)} ${vm.$t(`${vm.i18nPrefix}.label.month`)}`
                } else {
                  totalWorkYearI18nName = `${Math.floor(totalWorkYear * 10) / 10} ${vm.$t(`${vm.i18nPrefix}.label.year`)}`
                }
                return totalWorkYearI18nName
              }
            })
            Object.defineProperty(candidate, 'aiSummaryContent', {
              configurable: true,
              enumerable: true,
              get () {
                return getI18nPropertyValue(candidate.ai_summary_info, 'ai_summary_cn', 'ai_summary_en')
              }
            })
          })

          candidateList.push(...resp.data)
        }
      })
      this.candidateTotalCount = candidateTotalCount
      this.needShowAiInterview = needShowAiInterview
      if (this.pagination.page === 1) {
        this.candidateList = candidateList
      } else {
        this.candidateList.push(...candidateList)
      }
      this.pagination.page = _.max(loadedPages)
      this.pagination.totalPage = totalPage
      this.listLoading = false
    },
    handleScrollBottom () {
      this.handelSearch(this.search, true)
    },
    handleOrderChange (prop, order) {
      this.listOrder.prop = prop
      this.listOrder.order = order
      this.candidateList = []
      this.handelSearch(this.search, false)
    },
    handleOpenDetail (rowData) {
      const candidateId = rowData.candidate.id
      const jobId = rowData.job.id
      rowData.reviewed = true
      const params = encodeURIComponent(JSON.stringify(this.parseSearchToParams(this.search)))
      const backUrl = encodeURIComponent(this.$route.fullPath)
      this.loadJobInfo()
      window.open(`
        /v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&list_params=${params}&back=${backUrl}
      `)
    },
    openDuplicateCandidateDetail (application) {
      const { candidateId, jobId } = application
      const backUrl = encodeURIComponent(this.$route.fullPath)
      window.open(`/v-admin/application/profile?candidate_id=${candidateId}&job_id=${jobId}&back=${backUrl}`)
    },
    handleCandidateStatusClick (rowData) {
      this.handleChangeStatusOperation(rowData)
    },
    handleChangeStatus (rowData, status) {
      this.handleChangeStatusOperation(rowData, status)
    },
    handleToRejectStatus (rowData) {
      let status = 'Disqualified'
      if (rowData.job.company.root_id === ROOT_COMPANY_ID.MSD) {
        status = null
      }
      this.handleChangeStatusOperation(rowData, status)
    },
    handleScrollToTop (listType) {
      this.$nextTick(() => {
        const candidateListRef = listType === 'table' ? this.$refs.tableContainer : this.$refs.cardContainer
        candidateListRef.scrollToTop && candidateListRef.scrollToTop()
      })
    },
    handleStatusFilter ($event, candidateStage, candidateStatus) {
      this.listLoading = true

      let statusList = []
      if (candidateStage) {
        statusList = _.map(candidateStage.statusList, item => item.key)
      } else if (candidateStatus) {
        statusList = [candidateStatus]
      }

      const search = this.$refs.filterList.search
      const key = FILTER_GROUP_TYPE.APPLICATION_DETAIL
      search[key].candidateStatus = statusList
      search[key]._exclude = _.filter(search[key]._exclude, item => item !== 'candidateStatus')
      this.$refs.filterList.resetSearch({ search })
    },
    handleReadStatusFilter () {
      this.listLoading = true
      const search = this.$refs.filterList.search
      const key = FILTER_GROUP_TYPE.APPLICATION_DETAIL
      const readStatus = READ_STATUS.UNREAD

      search[key].readStatus = readStatus
      this.$refs.filterList.resetSearch({ search })
    },
    handleOpenPotential () {
      this.$router.push(`/v-admin/job/${this.jobId}/potential/list`)
    },
    handleStatusChangedSuccess () {
      this.handelSearch(this.search, false, this.pagination.page)
    },
    async handleTalentPoolAIRecommended () {
      window.open(`/v-admin/ai-talent-recommendation/job/${this.jobId}/candidate/`)
    },
    expandChange (expand, groupKey) {
      const accountConfig = this.accountConfig
      _.set(accountConfig, `${APPLICATION_PAGE_KEY}.filterConfig.${groupKey}`, expand)
      this.setAccountConfig(accountConfig)
    }
  },
  watch: {
    candidateListLength () {
      if (this.isNoRefreshSelectedCandidateList) {
        return
      }
      if (this.$refs.tableContainer && (this.isSelectedAllCandidate || this.selectAllIsIndeterminate)) {
        this.$refs.tableContainer.refreshSelectAllCandidate()
      }
      if (this.$refs.cardContainer && (this.isSelectedAllCardCandidate || this.selectAllIsIndeterminate)) {
        _.forEach(this.candidateList, candidate => {
          if (!_.includes(this.cancelSelectedCandidateList, candidate) && !candidate.is_agency_uploaded_and_hid) {
            candidate.selected = true
          } else {
            candidate.selected = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  width: 100%;
  height: 100%;

  .applicant-list {
    .nps-chart-container {
      margin-top: 10px;
      padding-bottom: 14px;
      border-bottom: 1px solid #e7eaeb;

      .text {
        display: inline-block;

        .title {
          font-weight: bold;
        }

        .description {
          margin-top: 4px;
          font-size: 12px;

          .text {
            vertical-align: middle;
            color: #606266;
          }

          .tip-icon {
            vertical-align: middle;
            margin-left: 8px;
            font-size: 14px;
            color: #c0c4cc;
            cursor: pointer;
          }
        }
      }

      .nps-chart {
        display: inline-block;
        vertical-align: bottom;
        margin-left: 16px;
        width: 47px;
        height: 47px;
      }
    }

    .status-stage-board {
      position: relative;
      margin: 0 0 14px 14px;
      box-shadow: 0px 3px 6px -4px rgba(0,0,0,0.08);
      min-height: 80px;

      .applicant-count-container {
        display: flex;

        .count-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          flex: 1;
          position: relative;
          background: #fff;
          padding: 16px 0;

          .expand-button {
            cursor: pointer;
          }

          .number {
            font-size: 18px;
            line-height: 25px;
            height: 25px;
            font-weight: 400;
            color: #606266;
            cursor: pointer;

            &:hover {
              color: #0096cc;
            }
          }

          .label {
            margin-top: 5px;
            font-size: 14px;
            color: #909399;
            font-weight: 400;
            line-height: 20px;
            height: 20px;
          }

          .un-read-container {
            color: #0096cc;
            font-size: 12px;
            line-height: 1;
            font-weight: bold;
            text-align: right;
            position: absolute;
            top: -7px;
            right: -14px;
            cursor: pointer;
          }

          .el-icon-caret-bottom {
            font-size: 14px;
            color: #909399;
          }

          .number-box {
            display: flex;
            align-items: center;
          }

          &::after {
            content: '';
            width: 1px;
            background: #dcdfe6;
            margin: 16px 0;
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
          }

          &.total {
            .number {
              position: relative;

              &:hover {
                color: #606266;
              }

              .text {
                &:hover {
                  color: #0096cc;
                }
              }
            }
          }

          &.screen {
          }

          &.offer {
          }

          &.interview {
          }

          &.leads {
            margin-left: 14px;
            &::after {
              display: none;
            }
          }

          &.hired {
            &::after {
              display: none;
            }
          }

          &.open-days {
            margin-left: 14px;

            .number {
              cursor: unset;

              &:hover {
                color: #606266;
              }
            }

            &::after {
              display: none;
            }
          }
        }
      }

      .loading {
        position: absolute;
        inset: 0;
      }
    }

    .last-work {
      margin-top: 6px;
    }

    .filter-label {
      line-height: 20px;
      vertical-align: middle;
    }

    .filter-tip-icon {
      color: #606266;
      margin-left: 4px;
      font-size: 14px;
      line-height: 20px;
      vertical-align: top;
    }
  }

  .rate-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .interview-dialog {
    ::v-deep {
      .el-dialog {
        margin: auto;

        .el-dialog__body {
          padding: 30px 30px;
        }
      }
    }
  }

  .change-candidate-status-dialog {
    ::v-deep {
      .el-dialog__header {
        padding: 34px 40px 0px;
      }

      .el-dialog__body {
        padding: 0px 40px 16px;
      }

      .el-dialog__title {
        font-size: 22px;
        font-weight: 500;
        color: #303133;
      }
    }
  }

  .confirm-create-job-criterion-dialog {
    .dialog-footer {
      .footer-btn  {
        border-radius: 2px;
        padding: 10px 30px;
      }
      .cancel-btn {
        height: 40px;
      }
      .save-btn {
        background: #0096cc;
        border-color: #0096cc;
        color: #ffffff;
        .label {
          vertical-align: middle;
        }
        .btn-icon {
          margin-left: 4px;
          font-size: 18px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.school-popper, .applied-job-popper, .consent-info-popper {
  max-width: 300px;

  .el-select-group__title {
    padding: 0px 20px;
  }

  .label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
